import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Stage, Layer, Rect, Image as KonvaImage, Transformer, Text, Group, Line, Label, Tag, Circle } from 'react-konva';
import { X, ZoomIn, ZoomOut, Check, Save, RotateCcw, AlertTriangle, Book, Download, Grid, Undo, Redo, Maximize, RotateCw, Wand2, Layout, Search, Plus, Trash2, ArrowRight, Minimize2, Maximize2, ChevronLeft, ChevronRight, Upload, History, MonitorPlay, BrainCircuit, List, Target, GraduationCap, MoreHorizontal, MousePointer, Square, Move, CheckCircle, Copy, Layers, AlertCircle, RefreshCw, Tag as TagIcon, Zap, FileImage, Loader2, Sparkles } from 'lucide-react';
import useImage from 'use-image';
import LearningPanel from './LearningPanel';
import TrainingDataPanel from './TrainingDataPanel';

/**
 * OCR ?쇰꺼留?紐⑤떖 而댄룷?뚰듃
 * 
 * @param {string} templateId - ?쒗뵆由?ID
 * @param {string} templateName - ?쒗뵆由??대쫫
 * @param {string} imageUrl - ?쇰꺼留곹븷 ?대?吏 URL
 * @param {function} onClose - ?リ린 肄쒕갚
 * @param {function} onSave - ???肄쒕갚
 * @param {number} totalPages - ?꾩껜 ?섏씠吏 ??
 * @param {number} currentPage - ?꾩옱 ?섏씠吏 (1-indexed)
 * @param {function} onPageChange - ?섏씠吏 蹂寃?肄쒕갚
 */
function OCRLabelingModal({
    templateId,
    templateName = 'Unknown Template',
    imageUrl,
    fileName, // 🏷️ Added fileName prop
    onClose,
    onSave,
    totalPages = 1,
    currentPage = 1,
    onPageChange,
    apiBaseUrl = '',
    templateFields = [],  // 템플릿 필드 목록
    //  임베디드 모드용 props
    isEmbedded = false,           // 모달  임베디드 모드
    disableAutoLabel = false,     // Auto Label 버튼 숨김
    initialBoundingBoxes = [],    // 초기 bbox 데이터
    ocrImageSize = null,          // OCR 이미지 사이즈
    highlightedFieldKey = null    // ⭐ 하이라이트할 필드 키 (필드 클릭 시)
}) {
    // ============ State ============
    // 🎯 임베디드 모드에서 초기 labels 바로 설정
    const [labels, setLabels] = useState(() => {
        if (isEmbedded && initialBoundingBoxes && initialBoundingBoxes.length > 0) {
            console.log('📦 [초기화] 임베디드 모드 - useState에서 labels 설정:', initialBoundingBoxes.length);
            return initialBoundingBoxes.map((box, idx) => {
                let x, y, width, height;
                if (box.bbox && typeof box.bbox.x === 'number') {
                    x = box.bbox.x; y = box.bbox.y;
                    width = box.bbox.width; height = box.bbox.height;
                } else if (typeof box.x === 'number') {
                    x = box.x; y = box.y;
                    width = box.width; height = box.height;
                } else if (box.box && Array.isArray(box.box) && box.box[0]) {
                    const pts = box.box;
                    x = pts[0][0]; y = pts[0][1];
                    width = pts[1][0] - pts[0][0];
                    height = pts[2][1] - pts[0][1];
                } else {
                    return null;
                }
                return {
                    id: `init-${idx}`,
                    bbox: { x, y, width, height },
                    text: box.text || '',
                    fieldKey: box.key || box.fieldKey || '',
                    source: 'embedded'
                };
            }).filter(Boolean);
        }
        return [];
    });
    const [allPageLabels, setAllPageLabels] = useState({});  // ?섏씠吏蹂??쇰꺼 { "1": [...], "2": [...] }
    const [selectedId, setSelectedId] = useState(null);
    const [isDrawing, setIsDrawing] = useState(false);
    const [newRect, setNewRect] = useState(null);
    const [tool, setTool] = useState('select');  // 'select' | 'draw'
    const [scale, setScale] = useState(1);
    const [stageSize, setStageSize] = useState({ width: 800, height: 600 });
    const [isSaving, setIsSaving] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);
    const [editingLabelId, setEditingLabelId] = useState(null);
    const [editingFieldKey, setEditingFieldKey] = useState('');
    const [showGrid, setShowGrid] = useState(false);  // 洹몃━???쒖떆 ?좉?
    const [clipboardLabel, setClipboardLabel] = useState(null);  // 蹂듭궗???쇰꺼
    const [isAutoLabeling, setIsAutoLabeling] = useState(false);  // ?먮룞 ?쇰꺼留?以?
    const [selectedIds, setSelectedIds] = useState([]);  // ?ㅼ쨷 ?좏깮???쇰꺼 IDs
    const [showHelpModal, setShowHelpModal] = useState(false);  // 단축키/도움말
    const [learningSelectedId, setLearningSelectedId] = useState(null); // 학습 탭 선택된 ID

    // ?넅 ?ㅻ쭏??留ㅽ븨 紐⑤뱶 ?곹깭
    const [smartMappingMode, setSmartMappingMode] = useState(false);

    // Learning Tab State
    const [activeTab, setActiveTab] = useState('results'); // 'results' | 'learning' | 'training'
    const [savedImagePath, setSavedImagePath] = useState(null); // Absolute path from server after verify

    // 🏷️ Training Tab State
    // (Removed: moved to TrainingDataPanel)

    // Data Load & Toast State
    const [loadedMsg, setLoadedMsg] = useState(null); // Toast message state

    // Help Modal Tab State
    const [helpTab, setHelpTab] = useState('shortcuts'); // 'shortcuts' | 'guide'

    // Guided Workflow State
    const [workflowStep, setWorkflowStep] = useState(1); // 1: Labeling, 2: Verified, 3: Training
    const [isSaved, setIsSaved] = useState(false); // 저장 완료 여부

    // 🤖 AI Merge Preview Modal State
    const [showMergePreview, setShowMergePreview] = useState(false);
    const [mergePreviewData, setMergePreviewData] = useState(null); // { fieldKey: value, ... }

    // Inline Editing State
    const [editingId, setEditingId] = useState(null);
    const [editingFieldId, setEditingFieldId] = useState(null);  // ⭐ Field 드롭다운용
    const [editText, setEditText] = useState("");

    // ⭐ Prompt Editor Modal State
    const [showPromptEditor, setShowPromptEditor] = useState(false);
    const [promptData, setPromptData] = useState(null);  // { ocrMerge: {...}, gemini: {...} }
    const [customOcrMergePrompt, setCustomOcrMergePrompt] = useState('');
    const [customGeminiPrompt, setCustomGeminiPrompt] = useState('');
    const [promptLoading, setPromptLoading] = useState(false);
    const [activePromptTab, setActivePromptTab] = useState('ocrMerge');  // 'ocrMerge' | 'gemini'
    const [promptLanguage, setPromptLanguage] = useState('ko');  // 'ko' | 'en' 한글/영문


    // 🔴 문자별 차이점 하이라이트 함수
    const renderDiffText = (text1, text2) => {
        if (!text1 || !text2 || text1 === text2) {
            return <span className="text-gray-600">{text1 || '-'}</span>;
        }

        const result = [];
        const maxLen = Math.max(text1.length, text2.length);

        for (let i = 0; i < text1.length; i++) {
            if (i < text2.length && text1[i] === text2[i]) {
                result.push(<span key={i} className="text-gray-600">{text1[i]}</span>);
            } else {
                result.push(<span key={i} className="text-red-500 font-bold">{text1[i]}</span>);
            }
        }

        return <>{result}</>;
    };

    const [panelWidth, setPanelWidth] = useState(600);

    // ⭐ Show OCR Box Labels State (default OFF)
    const [showBoxLabels, setShowBoxLabels] = useState(false);

    const handleEditStart = (label, e) => {
        e.stopPropagation();
        setEditingId(label.id);
        setEditText(label.text);
    };

    const handleEditSave = (id) => {
        if (!editText.trim()) return;
        setLabels(prev => prev.map(l => l.id === id ? { ...l, text: editText } : l));
        setEditingId(null);
    };

    const handleEditKeyDown = (e, id) => {
        if (e.key === 'Enter') {
            handleEditSave(id);
        } else if (e.key === 'Escape') {
            setEditingId(null);
        }
    };

    // 🏷️ Training Logic
    // (Removed: moved to TrainingDataPanel)

    // Tab change handler
    const handleTabChange = (tab) => {
        setActiveTab(tab);
        if (tab === 'training') {
            setWorkflowStep(3);
        } else if (tab === 'learning') {
            // Keep current step or maybe 2?
        }
    };

    const [ocrResults, setOcrResults] = useState([]);  // ?꾩껜 OCR 寃곌낵
    const [autoMatches, setAutoMatches] = useState([]);  // ?먮룞 留ㅼ묶 寃곌낵
    const [selectedOcrIds, setSelectedOcrIds] = useState([]);  // ?좏깮??OCR 諛뺤뒪 IDs
    const [mappingTarget, setMappingTarget] = useState(null);  // 留ㅽ븨 ????꾨뱶

    // Undo/Redo ?덉뒪?좊━
    const [history, setHistory] = useState([]);
    const [historyIndex, setHistoryIndex] = useState(-1);
    const isUndoRedo = useRef(false);  // Undo/Redo 以??덉뒪?좊━ 異붽? 諛⑹?

    const GRID_SIZE = 20;  // 洹몃━??媛꾧꺽 (?쎌?)
    const MOVE_STEP = 1;   // ?붿궡?????대룞 ?⑥쐞
    const MAX_HISTORY = 50;  // 理쒕? ?덉뒪?좊━ ??
    const MIN_SCALE = 0.25;  // 理쒖냼 以?(25%)
    const MAX_SCALE = 4;     // 理쒕? 以?(400%)
    const ZOOM_STEP = 0.1;   // 以??⑥쐞 (10%)

    // ============ Refs ============
    const stageRef = useRef(null);
    const transformerRef = useRef(null);
    const containerRef = useRef(null);
    const shapeRefs = useRef({});
    const rowRefs = useRef({}); // Refs for coordinate rows

    // ============ Image Loading ============
    // Support internal image switching (e.g. from Training Data Panel)
    const [currentImageUrl, setCurrentImageUrl] = useState(imageUrl);

    // Sync prop changes to internal state
    useEffect(() => {
        if (imageUrl) setCurrentImageUrl(imageUrl);
    }, [imageUrl]);

    useEffect(() => {
        console.log('🖼️ [OCRLabelingModal] Current Image:', currentImageUrl);
    }, [currentImageUrl]);

    const [image, imageStatus] = useImage(currentImageUrl || '', 'anonymous');

    // 🎯 임베디드 모드: initialBoundingBoxes로 labels 초기화 (image 로드 후에도 실행)
    useEffect(() => {
        console.log('🔍 [OCRLabelingModal] 임베디드 모드 체크:', {
            isEmbedded,
            boxCount: initialBoundingBoxes?.length || 0,
            hasImage: !!image,
            currentLabels: labels.length
        });
        // 이미지가 로드되고 labels가 비어있을 때 강제 동기화
        if (isEmbedded && initialBoundingBoxes && initialBoundingBoxes.length > 0) {
            console.log('📦 [OCRLabelingModal] 임베디드 모드 - initialBoundingBoxes 로드:', initialBoundingBoxes.length);
            // bbox 형식 변환: {bbox: {x,y,w,h}} → konva rect 형식
            const convertedLabels = initialBoundingBoxes.map((box, idx) => {
                let x, y, width, height;
                if (box.bbox && typeof box.bbox.x === 'number') {
                    x = box.bbox.x;
                    y = box.bbox.y;
                    width = box.bbox.width;
                    height = box.bbox.height;
                } else if (typeof box.x === 'number') {
                    x = box.x;
                    y = box.y;
                    width = box.width;
                    height = box.height;
                } else if (box.box && Array.isArray(box.box) && box.box[0]) {
                    const pts = box.box;
                    x = pts[0][0];
                    y = pts[0][1];
                    width = pts[1][0] - pts[0][0];
                    height = pts[2][1] - pts[0][1];
                } else {
                    console.warn('⚠️ 알 수 없는 bbox 형식:', box);
                    return null;
                }
                return {
                    id: `embedded-${idx}`,
                    bbox: { x, y, width, height },  // 🎯 Konva 렌더링과 호환되는 형식
                    text: box.text || '',
                    fieldKey: box.key || box.fieldKey || '',
                    source: 'embedded'
                };
            }).filter(Boolean);
            console.log('✅ [OCRLabelingModal] 변환된 labels:', convertedLabels.length, 'sample:', convertedLabels[0], 'originalBox:', initialBoundingBoxes[0]);
            // 🎯 labels가 비어있거나 다를 때만 설정
            if (labels.length === 0 || labels.length !== convertedLabels.length) {
                console.log('🔄 [OCRLabelingModal] labels 강제 동기화');
                setLabels(convertedLabels);
            }
        }
    }, [isEmbedded, initialBoundingBoxes, image]);

    // Callback for TrainingDataPanel to switch image
    // Callback for TrainingDataPanel to switch image
    const handleSwitchImage = (url, force = false, fileName = null) => {
        // 확인 대화상자 없이 바로 이미지 전환
        {
            setCurrentImageUrl(url);
            // 🎯 임베디드 모드에서는 labels 리셋하지 않음 (initialBoundingBoxes 유지)
            if (!isEmbedded) {
                setLabels([]); // Reset labels for new image
            }
            setOcrResults([]); // Clear OCR
            setWorkflowStep(1); // Back to Labeling
            setSavedImagePath(null);
            // 메시지 제거: 불필요한 알림은 표시하지 않음
        }
    };


    // ?대?吏 濡쒕뱶 ??珥덇린 ?ㅼ???怨꾩궛
    const [initialScale, setInitialScale] = useState(1);

    useEffect(() => {
        if (image && containerRef.current) {
            const containerWidth = containerRef.current.offsetWidth - 40;  // 패딩 제외
            const containerHeight = containerRef.current.offsetHeight - 40;

            // 🎯 임베디드 모드에서 컨테이너 크기가 너무 작으면 기본값 사용
            const effectiveWidth = containerWidth > 100 ? containerWidth : 600;
            const effectiveHeight = containerHeight > 100 ? containerHeight : 400;

            const imageAspect = image.width / image.height;
            const containerAspect = effectiveWidth / effectiveHeight;

            let fitScale;
            if (imageAspect > containerAspect) {
                fitScale = effectiveWidth / image.width;
            } else {
                fitScale = effectiveHeight / image.height;
            }

            // 🎯 임베디드 모드에서 기본 50%, 일반 모드에서 fit
            if (isEmbedded) {
                fitScale = 0.5;  // 50% 기본 뷰잉
            } else {
                fitScale = Math.max(0.3, Math.min(1.0, fitScale));
            }
            console.log('📐 [OCRLabelingModal] fitScale:', fitScale, 'isEmbedded:', isEmbedded);

            setInitialScale(fitScale);
            setScale(fitScale);
            setStageSize({ width: image.width * fitScale, height: image.height * fitScale });
        }
    }, [image, isEmbedded]);

    // scale 蹂寃???stageSize ?낅뜲?댄듃
    useEffect(() => {
        if (image) {
            setStageSize({ width: image.width * scale, height: image.height * scale });
        }
    }, [scale, image]);

    // Transformer ?낅뜲?댄듃
    useEffect(() => {
        if (selectedId && transformerRef.current && shapeRefs.current[selectedId]) {
            transformerRef.current.nodes([shapeRefs.current[selectedId]]);
            transformerRef.current.getLayer().batchDraw();
        } else if (transformerRef.current) {
            transformerRef.current.nodes([]);
        }
    }, [selectedId]);

    // ?쇰꺼 濡쒕뱶
    useEffect(() => {
        loadLabels();
    }, [templateId]);

    // ?섏씠吏 蹂寃????쇰꺼 ?숆린??
    // 페이지 변경 시 라벨 동기화
    useEffect(() => {
        if (allPageLabels[currentPage]) {
            setLabels(allPageLabels[currentPage]);
        } else {
            setLabels([]);
        }
    }, [currentPage, allPageLabels]);

    // Scroll to selected coordinate row
    useEffect(() => {
        if (selectedId && rowRefs.current[selectedId]) {
            rowRefs.current[selectedId].scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [selectedId]);

    // ============ API Functions ============



    const loadLabels = async () => {
        if (!templateId) return;
        try {
            const res = await fetch(`${apiBaseUrl}/api/templates/${templateId}/labels`);
            if (res.ok) {
                const data = await res.json();
                if (data.labels && Object.keys(data.labels).length > 0) {
                    setAllPageLabels(data.labels);
                    // Show toast if there are labels for current page
                    if (data.labels[currentPage] && data.labels[currentPage].length > 0) {
                        setLoadedMsg(`💾 이전 작업 내용(${data.labels[currentPage].length}개)을 불러왔습니다.`);
                        setTimeout(() => setLoadedMsg(null), 3000);
                    }
                } else {
                    setAllPageLabels({});
                }
                if (data.labels && data.labels[currentPage]) {
                    setLabels(data.labels[currentPage]);
                } else {
                    setLabels([]);
                }
            }
        } catch (error) {
            console.error('?쇰꺼 濡쒕뱶 ?ㅽ뙣:', error);
        }
    };

    const saveLabels = async () => {
        if (!templateId) return;
        setIsSaving(true);
        try {
            // ?꾩옱 ?섏씠吏 ?쇰꺼 ?낅뜲?댄듃
            const updatedLabels = { ...allPageLabels, [currentPage]: labels };

            const res = await fetch(`${apiBaseUrl}/api/templates/${templateId}/labels`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ labels: updatedLabels })
            });

            if (res.ok) {
                setAllPageLabels(updatedLabels);
                onSave && onSave(updatedLabels);
                alert('라벨이 저장되었습니다.');
            }
        } catch (error) {
            console.error('라벨 저장 실패:', error);
            alert('저장 중 오류가 발생했습니다.');
        } finally {
            setIsSaving(false);
        }
    };

    const handleVerifyAndSave = async () => {
        if (!labels || labels.length === 0) {
            alert('최소 1개 이상의 라벨이 필요합니다.');
            return;
        }

        setIsVerifying(true);
        try {
            const formData = new FormData();

            // Image processing: Always upload as file
            if (imageUrl) {
                try {
                    // Fetch image to convert to blob (works for blob: URLs and local http URLs)
                    const response = await fetch(imageUrl);
                    const blob = await response.blob();

                    // Determine filename
                    let filename = 'labeling_sample.png';
                    if (blob.type === 'image/jpeg') filename = 'labeling_sample.jpg';
                    else if (imageUrl.toLowerCase().endsWith('.jpg') || imageUrl.toLowerCase().endsWith('.jpeg')) filename = 'labeling_sample.jpg';

                    formData.append('image', blob, filename);
                    console.log('📸 Image uploaded as blob:', filename, blob.size);
                } catch (e) {
                    console.error('Image fetch failed, falling back to path:', e);
                    formData.append('imagePath', imageUrl);
                }
            }

            formData.append('labels', JSON.stringify(labels));
            formData.append('imageSize', JSON.stringify({ width: image?.width || 0, height: image?.height || 0 }));

            const res = await fetch(`${apiBaseUrl}/api/learning/verify`, {
                method: 'POST',
                body: formData
            });

            if (res.ok) {
                const data = await res.json();
                setSavedImagePath(data.savedPath); // Store absolute path for Learning Tab
                // 저장 경로 표시 (User Request: "어디 폴더에 저장되었는지 명확하게 알려줘")
                alert(`✅ 검증 및 저장 완료!\n\n📂 저장 위치:\n${data.savedPath}\n\n데이터가 '학습용(Ground Truth)'으로 안전하게 저장되었습니다.\n(작업을 계속하시려면 창을 닫지 마세요.)`);

                // Regular Save Process
                if (onSave) {
                    const updatedLabels = { ...allPageLabels, [currentPage]: labels };
                    setAllPageLabels(updatedLabels);
                    onSave(updatedLabels);
                }

                // Update Workflow Step to 2 (Verified)
                setWorkflowStep(2);
            } else {
                const err = await res.json();
                throw new Error(err.error || 'Unknown error');
            }
        } catch (error) {
            console.error('Verify failed:', error);
            alert(`검증 실패: ${error.message}`);
        } finally {
            setIsVerifying(false);
        }
    };

    // ============ Canvas Event Handlers ============

    const handleMouseDown = (e) => {
        // 鍮??곸뿭 ?대┃ ???좏깮 ?댁젣
        const clickedOnEmpty = e.target === e.target.getStage() || e.target.attrs.image;

        if (clickedOnEmpty) {
            setSelectedId(null);

            if (tool === 'draw') {
                setIsDrawing(true);
                const stage = stageRef.current;
                const pos = stage.getPointerPosition();
                setNewRect({
                    x: pos.x / scale,
                    y: pos.y / scale,
                    width: 0,
                    height: 0
                });
            }
        }
    };

    const handleMouseMove = (e) => {
        if (!isDrawing || tool !== 'draw') return;

        const stage = stageRef.current;
        const pos = stage.getPointerPosition();

        setNewRect(prev => ({
            ...prev,
            width: (pos.x / scale) - prev.x,
            height: (pos.y / scale) - prev.y
        }));
    };

    const handleMouseUp = () => {
        if (!isDrawing || !newRect) return;

        // 理쒖냼 ?ш린 泥댄겕 (10x10 ?쎌?)
        if (Math.abs(newRect.width) > 10 && Math.abs(newRect.height) > 10) {
            const normalizedRect = {
                x: newRect.width < 0 ? newRect.x + newRect.width : newRect.x,
                y: newRect.height < 0 ? newRect.y + newRect.height : newRect.y,
                width: Math.abs(newRect.width),
                height: Math.abs(newRect.height)
            };

            const newLabel = {
                id: `label_${Date.now()}`,
                fieldKey: '',
                bbox: normalizedRect,
                pageNumber: currentPage
            };

            setLabels(prev => [...prev, newLabel]);
            setSelectedId(newLabel.id);
            setEditingLabelId(newLabel.id);
            setEditingFieldKey('');
        }

        setIsDrawing(false);
        setNewRect(null);
    };

    // ============ Undo/Redo Functions ============

    // ?덉뒪?좊━???꾩옱 ?곹깭 異붽?
    const pushHistory = (newLabels) => {
        if (isUndoRedo.current) return;

        setHistory(prev => {
            const newHistory = prev.slice(0, historyIndex + 1);
            newHistory.push(JSON.parse(JSON.stringify(newLabels)));
            if (newHistory.length > MAX_HISTORY) {
                newHistory.shift();
            }
            return newHistory;
        });
        setHistoryIndex(prev => Math.min(prev + 1, MAX_HISTORY - 1));
    };

    // ?ㅽ뻾 痍⑥냼
    const undo = () => {
        if (historyIndex <= 0) return;

        isUndoRedo.current = true;
        const prevIndex = historyIndex - 1;
        setHistoryIndex(prevIndex);
        setLabels(JSON.parse(JSON.stringify(history[prevIndex])));
        setSelectedId(null);
        setTimeout(() => { isUndoRedo.current = false; }, 50);
    };

    // ?ㅼ떆 ?ㅽ뻾
    const redo = () => {
        if (historyIndex >= history.length - 1) return;

        isUndoRedo.current = true;
        const nextIndex = historyIndex + 1;
        setHistoryIndex(nextIndex);
        setLabels(JSON.parse(JSON.stringify(history[nextIndex])));
        setSelectedId(null);
        setTimeout(() => { isUndoRedo.current = false; }, 50);
    };

    // labels 蹂寃????덉뒪?좊━ 異붽?
    useEffect(() => {
        if (!isUndoRedo.current && labels.length > 0) {
            // 珥덇린 濡쒕뱶 ?쒖뿉??泥??덉뒪?좊━濡?異붽?
            if (history.length === 0) {
                setHistory([JSON.parse(JSON.stringify(labels))]);
                setHistoryIndex(0);
            } else {
                pushHistory(labels);
            }
        }
    }, [labels]);

    // ============ Label Handlers ============

    const handleLabelClick = (labelId, e) => {
        if (e?.evt?.ctrlKey || e?.ctrlKey) {
            // Ctrl+Click: Multi-Select Toggle
            setSelectedIds(prev =>
                prev.includes(labelId)
                    ? prev.filter(id => id !== labelId)
                    : [...prev, labelId]
            );
        } else {
            // Click: Single Select
            setSelectedId(labelId);
            setSelectedIds([labelId]);
        }
    };

    // Update Transformer when selection changes
    useEffect(() => {
        if (selectedId && transformerRef.current && shapeRefs.current[selectedId]) {
            // Attach transformer to the selected node
            const node = shapeRefs.current[selectedId];
            transformerRef.current.nodes([node]);
            transformerRef.current.getLayer().batchDraw();
        } else if (transformerRef.current) {
            // Detach if nothing selected
            transformerRef.current.nodes([]);
            transformerRef.current.getLayer().batchDraw();
        }
    }, [selectedId]);

    // ============ Reset Handler ============
    const resetLabels = () => {
        if (window.confirm('모든 라벨을 초기화하시겠습니까?\n(저장된 데이터는 "Save"를 눌러야 덮어씌워집니다.)')) {
            setLabels([]);
            setAllPageLabels(prev => ({ ...prev, [currentPage]: [] }));
            setWorkflowStep(1); // Reset workflow step
            setLoadedMsg('🗑️ 모든 라벨이 초기화되었습니다.');
            setTimeout(() => setLoadedMsg(null), 3000);
        }
    };

    // ============ Smart Labeling Handler ============
    const handleSmartLabelClick = () => {
        if (labels.length === 0) {
            // If empty, just trigger it
            smartLabel();
        } else {
            // Toggle mode
            smartLabel();
        }
    };

    const handleTransformEnd = (labelId, e) => {
        const node = e.target; // Rect node
        const group = node.getParent(); // Group node
        const scaleX = node.scaleX();
        const scaleY = node.scaleY();

        // 스케일 리셋
        node.scaleX(1);
        node.scaleY(1);

        setLabels(prev => prev.map(label =>
            label.id === labelId
                ? {
                    ...label,
                    bbox: {
                        x: group.x() + node.x(),
                        y: group.y() + node.y(),
                        width: Math.max(5, node.width() * scaleX),
                        height: Math.max(5, node.height() * scaleY)
                    }
                }
                : label
        ));

        // Rect 위치 초기화 (state update로 리렌더링되겠지만 명시적 리셋)
        node.x(0);
        node.y(0);
    };

    const handleDragEnd = (labelId, e) => {
        const node = e.target;
        setLabels(prev => prev.map(label =>
            label.id === labelId
                ? {
                    ...label,
                    bbox: { ...label.bbox, x: node.x(), y: node.y() }
                }
                : label
        ));
    };

    const updateFieldKey = (labelId, fieldKey) => {
        setLabels(prev => prev.map(label =>
            label.id === labelId ? { ...label, fieldKey } : label
        ));
    };

    const deleteLabel = (labelId) => {
        setLabels(prev => prev.filter(label => label.id !== labelId));
        if (selectedId === labelId) setSelectedId(null);
    };

    const duplicateLabel = (labelId) => {
        const label = labels.find(l => l.id === labelId);
        if (label) {
            const newLabel = {
                ...label,
                id: `label_${Date.now()}`,
                bbox: {
                    ...label.bbox,
                    x: label.bbox.x + 20,
                    y: label.bbox.y + 20
                }
            };
            setLabels(prev => [...prev, newLabel]);
        }
    };

    // ============ Export ============

    const exportToPPOCRFormat = () => {
        // PaddleOCR ?숈뒿 ?щ㎎?쇰줈 ?대낫?닿린
        const exportData = labels.map(label => ({
            transcription: '###',  // 鍮??띿뒪??(?쇰꺼留곷쭔)
            points: [
                [label.bbox.x, label.bbox.y],
                [label.bbox.x + label.bbox.width, label.bbox.y],
                [label.bbox.x + label.bbox.width, label.bbox.y + label.bbox.height],
                [label.bbox.x, label.bbox.y + label.bbox.height]
            ],
            fieldKey: label.fieldKey,
            ignore: false
        }));

        const blob = new Blob([JSON.stringify(exportData, null, 2)], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `labels_page${currentPage}.json`;
        a.click();
        URL.revokeObjectURL(url);
    };

    // ============ Zoom Controls ============

    const zoomIn = () => {
        setScale(prev => Math.min(prev + ZOOM_STEP, MAX_SCALE));
    };

    const zoomOut = () => {
        setScale(prev => Math.max(prev - ZOOM_STEP, MIN_SCALE));
    };

    const resetZoom = () => {
        setScale(1);
    };

    const fitToWindow = () => {
        if (!image || !containerRef.current) return;
        const containerRect = containerRef.current.getBoundingClientRect();
        const padding = 40;  // ?щ갚
        const scaleX = (containerRect.width - padding) / image.width;
        const scaleY = (containerRect.height - padding) / image.height;
        setScale(Math.min(scaleX, scaleY, 1));  // 理쒕? 100%
    };

    const handleRotate = async () => {
        if (!window.confirm('Rotate image 90 degrees? Existing labels will be cleared.')) return;

        setLoadedMsg('Rotating...');
        try {
            // Extract filename from URL (e.g., /raw-images/foo.png)
            const filename = currentImageUrl.split('/').pop().split('?')[0];
            const response = await fetch(`${apiBaseUrl}/api/learning/raw-images/${encodeURIComponent(filename)}/rotate`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ angle: 90 })
            });
            const data = await response.json();
            if (data.success) {
                // Force reload image logic
                // React-use-image caches by URL, so we append timestamp
                const newUrl = `${apiBaseUrl}${data.url}`; // backend returns url with ts
                setCurrentImageUrl(newUrl);
                setLabels([]);
                setOcrResults([]);
                setLoadedMsg('Image rotated successfully.');
                setTimeout(() => setLoadedMsg(null), 2000);
            } else {
                alert('Rotation failed: ' + data.message);
                setLoadedMsg(null);
            }
        } catch (error) {
            console.error('Rotate error:', error);
            alert('Rotation error.');
            setLoadedMsg(null);
        }
    };

    const handlePaddleOnly = async () => {
        setLoadedMsg('Detecting Text (Fast)...');
        console.log('⚡ [handlePaddleOnly] Using Image URL:', currentImageUrl); // DEBUG
        try {
            const filename = currentImageUrl.split('/').pop().split('?')[0];
            console.log('⚡ [handlePaddleOnly] Extracted Filename:', filename); // DEBUG

            // Re-fetch raw file blob if needed
            const response = await fetch(currentImageUrl);
            const blob = await response.blob();
            console.log('⚡ [handlePaddleOnly] Blob Size:', blob.size, 'Type:', blob.type); // DEBUG
            const file = new File([blob], filename, { type: blob.type });

            const formData = new FormData();
            formData.append('file', file);
            formData.append('pageNumber', currentPage);
            formData.append('originalFileName', filename);  // ⭐ For corrected image overwrite

            const res = await fetch(`${apiBaseUrl}/api/ocr/paddle-only`, {
                method: 'POST',
                body: formData
            });
            const data = await res.json();

            if (data.success) {
                // ⭐ Scale coordinates if ocrImageSize is provided
                let scaledLabels = data.labels;

                if (data.ocrImageSize && image) {
                    const ocrW = data.ocrImageSize.width;
                    const ocrH = data.ocrImageSize.height;
                    const displayW = image.width;
                    const displayH = image.height;

                    // Calculate scale ratio
                    const scaleX = displayW / ocrW;
                    const scaleY = displayH / ocrH;

                    console.log(`📐 [Scaling] OCR: ${ocrW}x${ocrH}, Display: ${displayW}x${displayH}, Scale: ${scaleX.toFixed(3)}x${scaleY.toFixed(3)}`);

                    // Scale each label's bbox
                    scaledLabels = data.labels.map(label => ({
                        ...label,
                        bbox: {
                            x: label.bbox.x * scaleX,
                            y: label.bbox.y * scaleY,
                            width: label.bbox.width * scaleX,
                            height: label.bbox.height * scaleY
                        }
                    }));
                }

                // ⭐ Always use corrected image for 1:1 coordinate matching (no scaling needed)
                if (data.correctedImageUrl) {
                    // Load corrected image from server URL with cache-busting timestamp
                    const fullUrl = `${apiBaseUrl}${data.correctedImageUrl}?t=${Date.now()}`;
                    setCurrentImageUrl(fullUrl);
                    console.log(`🔄 [Paddle-Only] Switched to corrected image: ${data.correctedImageUrl} (angle=${data.detectedAngle || 0}°)`);

                    // ⭐ No scaling needed - coordinates are 1:1 with corrected image
                    scaledLabels = data.labels.map(label => ({
                        ...label,
                        bbox: label.bbox  // Use coordinates as-is (1:1 matching)
                    }));
                }

                setLabels(scaledLabels);
                try {
                    pushHistory(scaledLabels); // Use existing pushHistory
                } catch (e) { console.warn("History push failed", e); }
                setLoadedMsg(`Detected ${scaledLabels.length} text regions.${data.detectedAngle ? ` (Rotated ${data.detectedAngle}°)` : ''}`);
                setTimeout(() => setLoadedMsg(null), 2000);
            } else {
                throw new Error(data.error);
            }

        } catch (error) {
            console.error(error);
            setLoadedMsg(null);
            alert('Failed to detect text: ' + error.message);
        }
    };

    // 🤖 vLLM 템플릿 기반 필드 병합 + 역매핑
    const handleMergeWithLLM = async () => {
        if (labels.length === 0) {
            alert('먼저 PaddleOCR을 실행하세요.');
            return;
        }
        if (templateFields.length === 0) {
            alert('템플릿 필드가 없습니다.');
            return;
        }

        setLoadedMsg('🤖 AI 병합 중...');

        try {
            const ocrBoxes = labels.map(label => ({
                text: label.text || '',
                bbox: label.bbox
            }));

            const response = await fetch(`${apiBaseUrl}/api/ocr/merge-with-llm`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    ocrBoxes: ocrBoxes,
                    templateFields: templateFields
                })
            });

            const data = await response.json();

            if (data.success) {
                const mergedData = data.data;
                console.log('🤖 [AI Merge] 결과:', mergedData);

                // ⭐ 역매핑: Gemini/vLLM 추출값으로 Unassigned 박스에 fieldKey 할당
                setLabels(prevLabels => {
                    const updatedLabels = [...prevLabels];
                    let totalMapped = 0;

                    // 각 추출된 필드값에 대해 매칭되는 bbox 찾기
                    for (const [fieldKey, extractedValue] of Object.entries(mergedData)) {
                        if (!extractedValue || typeof extractedValue !== 'string') continue;

                        const normalizedValue = extractedValue.replace(/[\s\-.,·()]/g, '').toLowerCase();
                        // 추출값을 조각으로 분리 (주소처럼 여러 줄로 나뉜 경우)
                        const valueParts = extractedValue.split(/[,\s]+/).filter(p => p.length >= 2);

                        // Unassigned 라벨 중에서 매칭 찾기 (⭐ 다중 박스 허용)
                        for (let i = 0; i < updatedLabels.length; i++) {
                            const label = updatedLabels[i];
                            if (label.fieldKey) continue; // 이미 할당된 것은 스킵
                            if (!label.text) continue;

                            const normalizedText = label.text.replace(/[\s\-.,·()]/g, '').toLowerCase();

                            // 정확 매칭
                            const isExactMatch = normalizedText === normalizedValue;
                            // 포함 매칭 (텍스트가 추출값에 포함되거나 그 반대)
                            const isContained = normalizedValue.includes(normalizedText) || normalizedText.includes(normalizedValue);
                            // 부분 매칭 (조각 중 하나라도 포함)
                            const isPartMatch = valueParts.some(part => {
                                const normalizedPart = part.replace(/[\s\-.,·()]/g, '').toLowerCase();
                                return normalizedPart.length >= 2 &&
                                    (normalizedText.includes(normalizedPart) || normalizedPart.includes(normalizedText));
                            });

                            const similarity = isExactMatch ? 1.0 :
                                (isContained && normalizedText.length >= 3 ? 0.9 :
                                    (isPartMatch && normalizedText.length >= 2 ? 0.7 : 0));

                            if (similarity >= 0.7) {
                                console.log(`✅ [역매핑] "${label.text}" → ${fieldKey} (유사도: ${(similarity * 100).toFixed(0)}%)`);
                                updatedLabels[i] = {
                                    ...label,
                                    fieldKey: fieldKey,
                                    text: label.text,  // PaddleOCR 텍스트 유지
                                    vllmText: extractedValue,  // ⭐ vLLM 값 저장 (Gemini 아님)
                                    source: 'ai-merge'
                                };
                                totalMapped++;
                                // ⭐ break 제거 - 다중 박스 매핑 허용 (주소 등)
                            }
                        }
                    }

                    console.log(`🎯 [AI Merge] 총 ${totalMapped}개 박스 역매핑 완료`);
                    return updatedLabels;
                });

                // 미리보기 모달 열기
                setMergePreviewData(mergedData);
                setShowMergePreview(true);
                setLoadedMsg(`✅ ${Object.keys(mergedData).length}개 필드 추출 & 역매핑 완료`);
                setTimeout(() => setLoadedMsg(null), 2000);
            } else {
                throw new Error(data.error || 'Unknown error');
            }
        } catch (error) {
            console.error('AI Merge Error:', error);
            setLoadedMsg(null);
            alert('AI 병합 실패: ' + error.message);
        }
    };

    // 🔮 Gemini Ground Truth 추출 (정답지)
    const handleGeminiExtract = async () => {
        if (!currentImageUrl) {
            alert('이미지를 먼저 선택하세요.');
            return;
        }

        setLoadedMsg('🔮 Gemini 추출 중...');

        try {
            // 현재 이미지를 blob으로 가져오기
            const response = await fetch(currentImageUrl);
            const blob = await response.blob();

            // FormData 생성
            const formData = new FormData();
            formData.append('file', blob, 'image.png');
            formData.append('templateId', templateId || '');
            formData.append('templateFields', JSON.stringify(templateFields || []));

            // Gemini 추출 API 호출
            const result = await fetch(`${apiBaseUrl}/api/ocr/gemini-extract`, {
                method: 'POST',
                body: formData
            });

            // 응답 상태 확인
            if (!result.ok) {
                const errorText = await result.text();
                throw new Error(`API 오류 (${result.status}): ${errorText.substring(0, 100)}`);
            }

            const data = await result.json();

            if (data.success) {
                console.log('🔮 [Gemini Extract] Ground Truth 결과:', data.data);

                // ⭐ Gemini 결과를 기존 labels의 geminiText로만 업데이트 (별도 행 추가하지 않음)
                setLabels(prev => {
                    // 기존 labels 복사
                    const updatedLabels = [...prev];

                    // data.data에서 각 필드의 값을 해당 labels에 geminiText로 설정
                    for (const [fieldKey, value] of Object.entries(data.data || {})) {
                        // 해당 fieldKey를 가진 labels 찾기
                        const matchingIndices = updatedLabels.map((l, i) => l.fieldKey === fieldKey ? i : -1).filter(i => i >= 0);

                        if (matchingIndices.length > 0) {
                            // 기존 labels에 geminiText 업데이트
                            matchingIndices.forEach(idx => {
                                updatedLabels[idx] = {
                                    ...updatedLabels[idx],
                                    geminiText: value
                                };
                            });
                            console.log(`✅ [Gemini] ${fieldKey}: ${matchingIndices.length}개 박스 업데이트`);
                        }
                    }

                    return updatedLabels;
                });

                const fieldCount = Object.keys(data.data || {}).length;
                setLoadedMsg(`✅ Gemini: ${fieldCount}개 필드 추출 완료`);
                setTimeout(() => setLoadedMsg(null), 3000);
            } else {
                throw new Error(data.error || 'Unknown error');
            }
        } catch (error) {
            console.error('Gemini Extract Error:', error);
            setLoadedMsg(null);
            alert('Gemini 추출 실패: ' + error.message);
        }
    };

    // ⭐ 프롬프트 에디터 열기 (API 호출하여 프롬프트 로드)
    const openPromptEditor = async (lang = promptLanguage) => {
        if (!templateId) {
            alert('템플릿을 먼저 선택하세요.');
            return;
        }

        setPromptLoading(true);
        setShowPromptEditor(true);

        try {
            const response = await fetch(`${apiBaseUrl}/api/templates/${templateId}/prompts?language=${lang}`);
            const data = await response.json();

            if (data.success) {
                setPromptData(data.prompts);
                setCustomOcrMergePrompt(data.prompts.ocrMerge.custom || '');
                setCustomGeminiPrompt(data.prompts.gemini.custom || '');
                console.log(`✅ [Prompt Editor] 프롬프트 로드 (${lang}):`, data.templateName);
            } else {
                throw new Error(data.error);
            }
        } catch (error) {
            console.error('Prompt Editor Error:', error);
            alert('프롬프트 로드 실패: ' + error.message);
        } finally {
            setPromptLoading(false);
        }
    };

    // ⭐ 언어 토글 (한글 ↔ 영문)
    const togglePromptLanguage = async (newLang) => {
        if (newLang === promptLanguage) return;
        setPromptLanguage(newLang);

        // 언어 변경 시 프롬프트 다시 로드 (Gemini 탭의 auto 프롬프트만 변경됨)
        setPromptLoading(true);
        try {
            const response = await fetch(`${apiBaseUrl}/api/templates/${templateId}/prompts?language=${newLang}`);
            const data = await response.json();
            if (data.success) {
                setPromptData(data.prompts);
                console.log(`🔄 [Prompt Editor] 언어 변경: ${newLang}`);
            }
        } catch (error) {
            console.error('Language toggle error:', error);
        } finally {
            setPromptLoading(false);
        }
    };

    // ⭐ 프롬프트 저장
    const savePrompts = async () => {
        if (!templateId) return;

        setPromptLoading(true);
        try {
            const response = await fetch(`${apiBaseUrl}/api/templates/${templateId}/prompts`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    customOcrMergePrompt: customOcrMergePrompt.trim() || null,
                    customGeminiPrompt: customGeminiPrompt.trim() || null
                })
            });

            const data = await response.json();
            if (data.success) {
                alert('✅ 프롬프트가 저장되었습니다.');
                setShowPromptEditor(false);
            } else {
                throw new Error(data.error);
            }
        } catch (error) {
            console.error('Prompt Save Error:', error);
            alert('프롬프트 저장 실패: ' + error.message);
        } finally {
            setPromptLoading(false);
        }
    };

    // 🤖 미리보기에서 값 수정
    const handleMergePreviewChange = (fieldKey, newValue) => {
        setMergePreviewData(prev => ({
            ...prev,
            [fieldKey]: newValue
        }));
    };

    // 🤖 미리보기 결과를 labels에 적용 + 학습 데이터로 저장
    const applyMergePreview = async () => {
        if (!mergePreviewData) return;

        console.log('🤖 [Apply Merge] 적용:', mergePreviewData);

        // 기존 labels 복사
        let updatedLabels = [...labels];

        // 템플릿 필드별로 vLLM 결과 매핑
        for (const field of templateFields) {
            const fieldKey = field.key || field.fieldKey || field.name;
            const mergedValue = mergePreviewData[fieldKey];

            if (mergedValue) {
                // 이미 해당 fieldKey를 가진 label이 있는지 확인
                const existingIdx = updatedLabels.findIndex(l => l.fieldKey === fieldKey);

                if (existingIdx >= 0) {
                    // 기존 label 업데이트 (vLLM 결과 적용)
                    updatedLabels[existingIdx] = {
                        ...updatedLabels[existingIdx],
                        text: mergedValue, // vLLM 병합 결과
                        paddleText: updatedLabels[existingIdx].text // 원본 보존
                    };
                } else {
                    // 새 label 생성 (템플릿 필드용)
                    updatedLabels.push({
                        id: `vllm-${fieldKey}-${Date.now()}`,
                        fieldKey: fieldKey,
                        text: mergedValue, // vLLM 병합 결과
                        paddleText: '', // PaddleOCR 원본 없음
                        source: 'vllm',
                        bbox: null // 좌표 없음 (병합된 결과)
                    });
                }
            }
        }

        setLabels(updatedLabels);

        // 🧠 수정된 데이터를 학습 데이터로 저장
        try {
            const ocrBoxes = labels.map(l => ({ text: l.text, bbox: l.bbox }));
            await fetch(`${apiBaseUrl}/api/ocr/save-correction`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    imageUrl: currentImageUrl,
                    templateId: templateId,
                    templateName: templateFields[0]?.templateName || templateId,
                    originalData: mergePreviewData, // vLLM 원본 결과 (수정 전도 같이 저장됨)
                    correctedData: mergePreviewData, // 사용자 수정 결과
                    ocrBoxes: ocrBoxes
                })
            });
            console.log('🧠 [Learning] 수정 데이터 저장됨');
        } catch (e) {
            console.warn('🧠 [Learning] 저장 실패:', e.message);
        }

        setShowMergePreview(false);
        setMergePreviewData(null);
        setLoadedMsg('✅ 병합 결과 적용 + 학습 데이터 저장됨');
        setTimeout(() => setLoadedMsg(null), 2000);
    };

    // ⚡ 자동 프로세스: OCR → AI병합 → Gemini → 교차검증 → 저장
    const [isAutoProcessing, setIsAutoProcessing] = useState(false);

    const handleAutoProcess = async () => {
        if (!currentImageUrl) {
            alert('먼저 이미지를 선택해주세요.');
            return;
        }

        setIsAutoProcessing(true);
        setLoadedMsg('⚡ 자동 프로세스 시작...');

        try {
            // Step 1: OCR (PaddleOCR)
            setLoadedMsg('1/4: OCR 인식 중...');
            await new Promise(resolve => {
                handleSmartLabelClick();
                // OCR 완료까지 대기 (isSmartLabeling이 false가 될 때까지)
                const checkOcr = setInterval(() => {
                    if (!isSmartLabeling) {
                        clearInterval(checkOcr);
                        resolve();
                    }
                }, 500);
                // 타임아웃 30초
                setTimeout(() => { clearInterval(checkOcr); resolve(); }, 30000);
            });

            // Step 2: AI병합 (vLLM) - 결과를 직접 가져옴
            setLoadedMsg('2/4: AI 병합 중...');
            const ocrTexts = labels.map(l => l.text).filter(Boolean);
            const vllmResponse = await fetch(`${apiBaseUrl}/api/ocr/local-llm-merge`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    ocrTexts,
                    templateFields: templateFields.map(f => f.key || f.fieldKey || f.name),
                    templateId,
                    hints: {}
                })
            });
            const vllmData = await vllmResponse.json();
            const vllmResults = vllmData.success ? vllmData.data : {};

            // Step 3: Gemini 호출
            setLoadedMsg('3/4: Gemini 검증 중...');
            const formData = new FormData();
            const filename = currentImageUrl.split('/').pop().split('?')[0];
            const imgResp = await fetch(currentImageUrl);
            const blob = await imgResp.blob();
            formData.append('image', blob, filename);
            formData.append('templateId', templateId);
            formData.append('templateFields', JSON.stringify(templateFields.map(f => f.key || f.fieldKey || f.name)));

            const geminiResp = await fetch(`${apiBaseUrl}/api/ocr/gemini-extract`, {
                method: 'POST',
                body: formData
            });
            const geminiData = await geminiResp.json();
            const geminiResults = geminiData.success ? geminiData.data : {};

            // Step 4: 교차검증
            setLoadedMsg('4/4: 교차검증 중...');
            let hasDifference = false;
            const differences = [];

            for (const field of templateFields) {
                const key = field.key || field.fieldKey || field.name;
                const vllmVal = (vllmResults[key] || '').toString().trim();
                const geminiVal = (geminiResults[key] || '').toString().trim();

                if (vllmVal !== geminiVal) {
                    hasDifference = true;
                    differences.push({ field: key, vllm: vllmVal, gemini: geminiVal });
                }
            }

            // 🎯 기존 labels 유지 (Detection Box 표시용) + 템플릿 필드 업데이트
            console.log('🔍 [Auto] geminiData keys:', Object.keys(geminiData));
            console.log('🔍 [Auto] geminiData.labels:', geminiData.labels);
            console.log('📦 [Auto] labels kept:', labels.length, 'boxes');

            let updatedLabels = [...labels];

            // 템플릿 필드별로 vLLM + Gemini 값 업데이트 + bboxes 매핑
            for (const field of templateFields) {
                const fieldKey = field.key || field.fieldKey || field.name;
                const vllmVal = vllmResults[fieldKey] || '';
                const geminiVal = geminiResults[fieldKey] || '';

                // ⭐ geminiData.labels에서 bboxes 배열 찾기 (다중 bbox 지원)
                const geminiLabel = geminiData.labels?.find(l => l.fieldKey === fieldKey);
                const bboxesFromGemini = geminiLabel?.bboxes || null;
                const bboxFromGemini = geminiLabel?.bbox || (bboxesFromGemini?.[0] || null);

                const existingIdx = updatedLabels.findIndex(l => l.fieldKey === fieldKey);
                if (existingIdx >= 0) {
                    updatedLabels[existingIdx] = {
                        ...updatedLabels[existingIdx],
                        text: vllmVal || updatedLabels[existingIdx].text,
                        geminiText: geminiVal,
                        source: 'vllm',
                        bboxes: bboxesFromGemini || updatedLabels[existingIdx].bboxes,
                        bbox: bboxFromGemini || updatedLabels[existingIdx].bbox
                    };
                } else {
                    updatedLabels.push({
                        id: `auto-${fieldKey}-${Date.now()}`,
                        fieldKey,
                        text: vllmVal,
                        geminiText: geminiVal,
                        source: 'vllm',
                        bboxes: bboxesFromGemini,
                        bbox: bboxFromGemini
                    });
                }
            }
            setLabels(updatedLabels);

            if (hasDifference) {
                // 불일치 → 사용자 검증 필요
                console.log('⚠️ 교차검증 불일치:', differences);
                setLoadedMsg(`⚠️ ${differences.length}개 필드 불일치 - 확인 후 저장하세요`);
                setWorkflowStep(1); // 검증 대기
            } else {
                // 일치 → 자동 저장
                console.log('✅ 교차검증 일치 - 자동 저장');
                setWorkflowStep(2);

                // 저장 API 호출
                try {
                    const ocrBoxes = updatedLabels.map(l => ({ text: l.text, bbox: l.bbox }));
                    await fetch(`${apiBaseUrl}/api/ocr/save-correction`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            imageUrl: currentImageUrl,
                            templateId,
                            templateName: templateFields[0]?.templateName || templateId,
                            originalData: vllmResults,
                            correctedData: vllmResults,
                            ocrBoxes
                        })
                    });
                    setIsSaved(true);
                    setLoadedMsg('✅ 자동 완료! (일치 → 저장됨)');
                } catch (e) {
                    setLoadedMsg('⚠️ 저장 실패: ' + e.message);
                }
            }
        } catch (error) {
            console.error('❌ 자동 프로세스 오류:', error);
            setLoadedMsg('❌ 오류: ' + error.message);
        } finally {
            setIsAutoProcessing(false);
            setTimeout(() => setLoadedMsg(null), 3000);
        }
    };

    // 🔄 OCR 버튼: PaddleOCR + AI병합 + Gemini 병렬 실행
    const [isOcrProcessing, setIsOcrProcessing] = useState(false);

    const handleOcrWithMerge = async () => {
        if (!currentImageUrl) return;

        setIsOcrProcessing(true);
        setLoadedMsg('🚀 OCR + Gemini 병렬 처리 중...');

        try {
            // Step 0: 이미지 Blob 가져오기
            const imgResp = await fetch(currentImageUrl);
            const blob = await imgResp.blob();
            const filename = currentImageUrl.split('/').pop().split('?')[0];

            // 🚀 병렬 실행: [PaddleOCR → vLLM] AND [Gemini]
            const paddleVllmPromise = (async () => {
                // PaddleOCR 호출
                const formData = new FormData();
                formData.append('file', blob, filename);
                formData.append('returnCorrectedImage', 'true');

                const paddleResp = await fetch(`${apiBaseUrl}/api/ocr/paddle-only`, {
                    method: 'POST',
                    body: formData
                });
                const paddleData = await paddleResp.json();

                if (!paddleData.success) {
                    throw new Error(paddleData.error || 'OCR 실패');
                }

                let ocrLabels = paddleData.labels || [];
                let correctedImageUrl = paddleData.correctedImageUrl;

                // vLLM 병합
                const ocrTexts = ocrLabels.map(l => l.text).filter(Boolean);
                let vllmData = null;

                if (ocrTexts.length > 0) {
                    try {
                        const vllmResp = await fetch(`${apiBaseUrl}/api/ocr/local-llm-merge`, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                ocrTexts,
                                templateFields: templateFields.map(f => f.key || f.fieldKey || f.name),
                                templateId,
                                hints: {}
                            })
                        });
                        if (vllmResp.ok) {
                            vllmData = await vllmResp.json();
                        }
                    } catch (e) {
                        console.warn('vLLM error:', e.message);
                    }
                }

                return { ocrLabels, correctedImageUrl, vllmData };
            })();

            const geminiPromise = (async () => {
                // Gemini 호출 (병렬)
                const formData = new FormData();
                formData.append('file', blob, filename);
                formData.append('templateId', templateId);
                formData.append('templateFields', JSON.stringify(templateFields.map(f => f.key || f.fieldKey || f.name)));

                try {
                    const geminiResp = await fetch(`${apiBaseUrl}/api/ocr/gemini-extract`, {
                        method: 'POST',
                        body: formData
                    });
                    if (geminiResp.ok) {
                        return await geminiResp.json();
                    }
                } catch (e) {
                    console.warn('Gemini error:', e.message);
                }
                return null;
            })();

            // 병렬 대기
            const [paddleVllm, geminiData] = await Promise.all([paddleVllmPromise, geminiPromise]);
            const { ocrLabels, correctedImageUrl, vllmData } = paddleVllm;

            // 보정된 이미지 URL 업데이트
            if (correctedImageUrl) {
                const fullUrl = `${apiBaseUrl}${correctedImageUrl}?t=${Date.now()}`;
                setCurrentImageUrl(fullUrl);
            }

            // 결과 합치기: OCR + vLLM + Gemini
            console.log('🔍 [OCR] geminiData keys:', geminiData ? Object.keys(geminiData) : 'null');
            console.log('🔍 [OCR] geminiData.labels:', geminiData?.labels);

            // 🎯 핵심: ocrLabels 전체 유지 (하단 Detection Box 표시용)
            let updatedLabels = [...ocrLabels];
            console.log('📦 [OCR] ocrLabels kept:', ocrLabels.length, 'boxes');

            // 템플릿 필드별로 vLLM + Gemini 값 추가/업데이트
            for (const field of templateFields) {
                const fieldKey = field.key || field.fieldKey || field.name;
                const vllmVal = vllmData?.success ? (vllmData.data[fieldKey] || '') : '';
                const geminiVal = geminiData?.success ? (geminiData.data[fieldKey] || '') : '';

                // ⭐ geminiData.labels에서 bboxes 배열 찾기 (다중 bbox 지원)
                const geminiLabel = geminiData?.labels?.find(l => l.fieldKey === fieldKey);
                const bboxesFromGemini = geminiLabel?.bboxes || null;
                const bboxFromGemini = geminiLabel?.bbox || (bboxesFromGemini?.[0] || null);

                // 🎯 다중 bbox와 매칭되는 ocrLabels에 fieldKey 할당
                if (bboxesFromGemini && bboxesFromGemini.length > 0) {
                    for (const geminiBbox of bboxesFromGemini) {
                        // bbox가 비슷한 ocrLabel 찾기 (좌표 근접)
                        const matchingOcrIdx = updatedLabels.findIndex(l => {
                            if (!l.bbox || l.fieldKey) return false; // 이미 fieldKey 있으면 스킵
                            const tolerance = 10; // 10px 오차 허용
                            return Math.abs(l.bbox.x - geminiBbox.x) < tolerance &&
                                Math.abs(l.bbox.y - geminiBbox.y) < tolerance;
                        });
                        if (matchingOcrIdx >= 0) {
                            console.log(`   🏷️ [OCR] Assigning "${fieldKey}" to box: "${updatedLabels[matchingOcrIdx].text}"`);
                            updatedLabels[matchingOcrIdx] = {
                                ...updatedLabels[matchingOcrIdx],
                                fieldKey: fieldKey
                            };
                        }
                    }
                }

                const existingIdx = updatedLabels.findIndex(l => l.fieldKey === fieldKey);
                if (existingIdx >= 0) {
                    // 기존 label 업데이트 (bboxes가 있으면 추가)
                    updatedLabels[existingIdx] = {
                        ...updatedLabels[existingIdx],
                        text: vllmVal || updatedLabels[existingIdx].text,
                        geminiText: geminiVal,
                        source: 'vllm',
                        bboxes: bboxesFromGemini || updatedLabels[existingIdx].bboxes,
                        bbox: bboxFromGemini || updatedLabels[existingIdx].bbox
                    };
                } else {
                    // 새 label 추가 (템플릿 필드)
                    updatedLabels.push({
                        id: `vllm-${fieldKey}-${Date.now()}`,
                        fieldKey,
                        text: vllmVal,
                        geminiText: geminiVal,
                        source: 'vllm',
                        bboxes: bboxesFromGemini,
                        bbox: bboxFromGemini
                    });
                }
            }

            setLabels(updatedLabels);

            // 결과 메시지
            const vllmOk = vllmData?.success;
            const geminiOk = geminiData?.success;
            if (vllmOk && geminiOk) {
                // 차이점 확인
                let diffCount = 0;
                for (const label of updatedLabels) {
                    if (label.fieldKey && label.text !== label.geminiText && (label.text || label.geminiText)) {
                        diffCount++;
                    }
                }
                if (diffCount > 0) {
                    setLoadedMsg(`✅ 완료! ⚠️ ${diffCount}개 필드 불일치 (검토 필요)`);
                } else {
                    setLoadedMsg(`✅ OCR + AI병합 + Gemini 완료 (일치!)`);
                }
                setWorkflowStep(2); // 검증 완료
            } else {
                setLoadedMsg(`✅ OCR(${ocrLabels.length}개) ${vllmOk ? '+vLLM' : ''} ${geminiOk ? '+Gemini' : ''}`);
            }

        } catch (error) {
            console.error('❌ OCR 병렬 처리 오류:', error);
            setLoadedMsg('❌ 오류: ' + error.message);
        } finally {
            setIsOcrProcessing(false);
            setTimeout(() => setLoadedMsg(null), 5000);
        }
    };

    // 🔍 검증 버튼: Gemini 호출 + 비교 (isVerifying은 상단에 이미 선언됨)

    const handleVerifyWithGemini = async () => {
        if (labels.length === 0) return;

        setIsVerifying(true);
        setLoadedMsg('Gemini로 검증 중...');

        try {
            // Gemini 호출
            const formData = new FormData();
            const filename = currentImageUrl.split('/').pop().split('?')[0];
            const imgResp = await fetch(currentImageUrl);
            const blob = await imgResp.blob();
            formData.append('file', blob, filename);
            formData.append('templateId', templateId);
            formData.append('templateFields', JSON.stringify(templateFields.map(f => f.key || f.fieldKey || f.name)));

            const geminiResp = await fetch(`${apiBaseUrl}/api/ocr/gemini-extract`, {
                method: 'POST',
                body: formData
            });
            const geminiData = await geminiResp.json();

            if (geminiData.success) {
                console.log('🔍 [Verify] geminiData keys:', Object.keys(geminiData));
                console.log('🔍 [Verify] geminiData.labels:', geminiData.labels);

                // 🎯 기존 labels 전체 유지 (Detection Box 표시용)
                let updatedLabels = [...labels];
                let hasDifference = false;
                console.log('📦 [Verify] labels kept:', labels.length, 'boxes');

                // 템플릿 필드별로 geminiText 업데이트 + bboxes 매핑
                for (const field of templateFields) {
                    const key = field.key || field.fieldKey || field.name;
                    const geminiVal = geminiData.data[key] || '';

                    // ⭐ geminiData.labels에서 bboxes 배열 찾기 (다중 bbox 지원)
                    const geminiLabel = geminiData.labels?.find(l => l.fieldKey === key);
                    const bboxesFromGemini = geminiLabel?.bboxes || null;
                    const bboxFromGemini = geminiLabel?.bbox || (bboxesFromGemini?.[0] || null);

                    const existingIdx = updatedLabels.findIndex(l => l.fieldKey === key);
                    if (existingIdx >= 0) {
                        const vllmVal = updatedLabels[existingIdx].text || '';
                        if (vllmVal && geminiVal && vllmVal !== geminiVal) hasDifference = true;

                        updatedLabels[existingIdx] = {
                            ...updatedLabels[existingIdx],
                            geminiText: geminiVal,
                            bboxes: bboxesFromGemini || updatedLabels[existingIdx].bboxes,
                            bbox: bboxFromGemini || updatedLabels[existingIdx].bbox
                        };
                    } else {
                        updatedLabels.push({
                            id: `gemini-${key}-${Date.now()}`,
                            fieldKey: key,
                            text: '',
                            geminiText: geminiVal,
                            source: 'gemini',
                            bboxes: bboxesFromGemini,
                            bbox: bboxFromGemini
                        });
                        hasDifference = true;
                    }
                }
                setLabels(updatedLabels);
                setWorkflowStep(2); // 검증 완료

                if (hasDifference) {
                    setLoadedMsg('⚠️ 차이 발견 - 빨간색으로 표시됨');
                } else {
                    setLoadedMsg('✅ 검증 완료 - 일치함');
                }
            } else {
                setLoadedMsg('❌ Gemini 오류');
            }
        } catch (error) {
            console.error('❌ 검증 오류:', error);
            setLoadedMsg('❌ 오류: ' + error.message);
        } finally {
            setIsVerifying(false);
            setTimeout(() => setLoadedMsg(null), 3000);
        }
    };

    const handleAutoRectify = async () => {
        if (!window.confirm('Run auto-rectification? This attempts to find an ID card and crop it. Existing labels will be cleared.')) return;
        setLoadedMsg('Rectifying...');
        try {
            const filename = currentImageUrl.split('/').pop().split('?')[0];
            const response = await fetch(`${apiBaseUrl}/api/learning/raw-images/${encodeURIComponent(filename)}/rectify`, {
                method: 'POST'
            });
            const data = await response.json();
            if (data.success) {
                const newUrl = `${apiBaseUrl}${data.url}`;
                setCurrentImageUrl(newUrl);
                setLabels([]);
                setOcrResults([]);
                setLoadedMsg('Auto-fix applied successfully.');
                setTimeout(() => setLoadedMsg(null), 2000);
            } else {
                alert('Rectification failed: ' + data.message);
                setLoadedMsg(null);
            }
        } catch (error) {
            console.error('Rectify error:', error);
            alert('Rectify error.');
            setLoadedMsg(null);
        }
    };

    const handleWheel = (e) => {
        e.evt.preventDefault();
        const scaleBy = 1.1;
        const stage = stageRef.current;
        const oldScale = scale;

        const newScale = e.evt.deltaY < 0
            ? Math.min(oldScale * scaleBy, MAX_SCALE)
            : Math.max(oldScale / scaleBy, MIN_SCALE);

        setScale(newScale);
    };

    // ============ Keyboard Shortcuts ============

    // ?쇰꺼 ?꾩튂 誘몄꽭 議곗젙
    const moveLabel = (dx, dy) => {
        if (!selectedId) return;
        setLabels(prev => prev.map(label =>
            label.id === selectedId
                ? { ...label, bbox: { ...label.bbox, x: label.bbox.x + dx, y: label.bbox.y + dy } }
                : label
        ));
    };

    // 瑗?쭞???몃? ?쒖뼱: z=醫뚯긽?? x=?곗긽?? c=?고븯?? v=醫뚰븯?? b=?꾩껜?ш린
    const resizeCorner = (corner, delta = 1) => {
        if (!selectedId) return;
        setLabels(prev => prev.map(label => {
            if (label.id !== selectedId) return label;
            const { x, y, width, height } = label.bbox;
            let newBbox = { x, y, width, height };

            switch (corner) {
                case 'tl': // z: 醫뚯긽??- x,y ?대룞, ?ш린 議곗젅
                    newBbox.x -= delta; newBbox.y -= delta;
                    newBbox.width += delta; newBbox.height += delta;
                    break;
                case 'tr': // x: ?곗긽??- y ?대룞, ?덈퉬 利앷?
                    newBbox.y -= delta;
                    newBbox.width += delta; newBbox.height += delta;
                    break;
                case 'br': // c: ?고븯??- ?ш린留?利앷?
                    newBbox.width += delta; newBbox.height += delta;
                    break;
                case 'bl': // v: 醫뚰븯??- x ?대룞, ?믪씠 利앷?
                    newBbox.x -= delta;
                    newBbox.width += delta; newBbox.height += delta;
                    break;
                case 'all': // b: ?꾩껜 1px???뺤옣
                    newBbox.x -= delta; newBbox.y -= delta;
                    newBbox.width += delta * 2; newBbox.height += delta * 2;
                    break;
            }
            // 理쒖냼 ?ш린 蹂댁옣
            newBbox.width = Math.max(10, newBbox.width);
            newBbox.height = Math.max(10, newBbox.height);
            return { ...label, bbox: newBbox };
        }));
    };

    // ?ㅻ깄 湲곕뒫 (洹몃━?쒖뿉 留욎땄)
    const snapToGrid = (value) => Math.round(value / GRID_SIZE) * GRID_SIZE;

    useEffect(() => {
        const handleKeyDown = (e) => {
            // ?낅젰 ?꾨뱶?먯꽌???⑥텞??鍮꾪솢?깊솕
            if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;

            if (e.key === 'Delete' && selectedId) {
                deleteLabel(selectedId);
            } else if (e.key === 'd' && e.ctrlKey && selectedId) {
                e.preventDefault();
                duplicateLabel(selectedId);
            } else if (e.key === 'z' && e.ctrlKey && !e.shiftKey) {
                // Ctrl+Z: ?ㅽ뻾 痍⑥냼
                e.preventDefault();
                undo();
            } else if ((e.key === 'y' && e.ctrlKey) || (e.key === 'z' && e.ctrlKey && e.shiftKey)) {
                // Ctrl+Y ?먮뒗 Ctrl+Shift+Z: ?ㅼ떆 ?ㅽ뻾
                e.preventDefault();
                redo();
            } else if (e.key === 'c' && e.ctrlKey && selectedId) {
                // Ctrl+C: 蹂듭궗
                e.preventDefault();
                const label = labels.find(l => l.id === selectedId);
                if (label) setClipboardLabel({ ...label });
            } else if (e.key === 'v' && e.ctrlKey && clipboardLabel) {
                // Ctrl+V: 遺숈뿬?ｊ린
                e.preventDefault();
                const newLabel = {
                    ...clipboardLabel,
                    id: `label_${Date.now()}`,
                    bbox: {
                        ...clipboardLabel.bbox,
                        x: clipboardLabel.bbox.x + 30,
                        y: clipboardLabel.bbox.y + 30
                    }
                };
                setLabels(prev => [...prev, newLabel]);
                setSelectedId(newLabel.id);
            } else if (e.key === 'g') {
                // G: 洹몃━???좉?
                setShowGrid(prev => !prev);
            } else if (e.key === 'Escape') {
                setSelectedId(null);
                setTool('select');
            } else if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key) && selectedId) {
                // ?붿궡???? 誘몄꽭 ?대룞
                e.preventDefault();
                const step = e.shiftKey ? 10 : MOVE_STEP;  // Shift ?꾨Ⅴ硫?10px ?대룞
                switch (e.key) {
                    case 'ArrowUp': moveLabel(0, -step); break;
                    case 'ArrowDown': moveLabel(0, step); break;
                    case 'ArrowLeft': moveLabel(-step, 0); break;
                    case 'ArrowRight': moveLabel(step, 0); break;
                }
            } else if (e.key === 'w' || e.key === 'W') {
                // W: 諛뺤뒪 洹몃━湲?紐⑤뱶
                setTool('draw');
            } else if (e.key === '?' || (e.key === '/' && e.shiftKey)) {
                // ?: ?⑥텞???꾩?留?
                setShowHelpModal(prev => !prev);
            } else if (selectedId && !e.ctrlKey) {
                // 瑗?쭞???몃? ?쒖뼱 (Shift: 異뺤냼)
                const delta = e.shiftKey ? -1 : 1;
                switch (e.key.toLowerCase()) {
                    case 'z': resizeCorner('tl', delta); break;  // 醫뚯긽??
                    case 'x': resizeCorner('tr', delta); break;  // ?곗긽??
                    case 'c':
                        if (!e.ctrlKey) resizeCorner('br', delta);  // ?고븯??
                        break;
                    case 'v':
                        if (!e.ctrlKey) resizeCorner('bl', delta);  // 醫뚰븯??
                        break;
                    case 'b': resizeCorner('all', delta); break;  // ?꾩껜
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [selectedId, clipboardLabel, labels]);

    // ============ Auto-Labeling ============

    const autoLabel = async () => {
        if (!imageUrl || isAutoLabeling) return;

        setIsAutoLabeling(true);
        try {
            console.log('?뤇截?[?먮룞 ?쇰꺼留? ?쒖옉...');

            // ?대?吏 URL?먯꽌 Blob 媛?몄삤湲?
            const response = await fetch(imageUrl);
            const blob = await response.blob();

            // FormData ?앹꽦
            const formData = new FormData();
            formData.append('file', blob, 'image.png');
            formData.append('pageNumber', currentPage.toString());

            // ⭐ Force absolute URL to bypass flaky frontend proxy
            const res = await fetch(`http://localhost:3002/api/ocr/paddle-only`, {
                method: 'POST',
                body: formData
            });

            const data = await res.json();

            if (data.success && data.labels) {
                console.log(`??[?먮룞 ?쇰꺼留? ${data.labels.length}媛??쇰꺼 ?앹꽦 (${data.elapsed}ms)`);
                setLabels(prev => [...prev, ...data.labels]);
            } else {
                console.error('???먮룞 ?쇰꺼留??ㅽ뙣:', data.error);
                alert('?먮룞 ?쇰꺼留??ㅽ뙣: ' + data.error);
            }
        } catch (error) {
            console.error('???먮룞 ?쇰꺼留??ㅻ쪟:', error);
            alert('?먮룞 ?쇰꺼留??ㅻ쪟: ' + error.message);
        } finally {
            setIsAutoLabeling(false);
        }
    };

    // ============ Progressive OCR (SSE 기반 점진적 업데이트) ============

    const [isProgressiveProcessing, setIsProgressiveProcessing] = useState(false);

    /**
     * ⭐ 새로운 OCR 파이프라인 (기존 엔드포인트 재사용)
     * 1. PaddleOCR (paddle-only) - 1초만에 완료 → 화면 표시
     * 2. AI Merge (merge-with-llm) + Gemini (gemini-extract) 병렬 실행
     */
    const handleOcrPipeline = async () => {
        if (!currentImageUrl || isProgressiveProcessing) return;
        if (!templateId || templateFields.length === 0) {
            alert('템플릿을 먼저 선택하세요.');
            return;
        }

        setIsProgressiveProcessing(true);
        console.log('🚀 [OCR Pipeline] 시작...');

        try {
            // =============================================
            // Step 1: PaddleOCR (paddle-only) - 1초
            // =============================================
            setLoadedMsg('⚡ PaddleOCR 처리 중...');
            console.log('⚡ [OCR Pipeline] Step 1: PaddleOCR...');

            const filename = currentImageUrl.split('/').pop().split('?')[0];
            const imageResponse = await fetch(currentImageUrl);
            const blob = await imageResponse.blob();
            const file = new File([blob], filename, { type: blob.type });

            const paddleFormData = new FormData();
            paddleFormData.append('file', file);
            paddleFormData.append('pageNumber', currentPage);
            paddleFormData.append('originalFileName', filename);

            const paddleStart = Date.now();
            const paddleRes = await fetch(`${apiBaseUrl}/api/ocr/paddle-only`, {
                method: 'POST',
                body: paddleFormData
            });
            const paddleData = await paddleRes.json();
            const paddleElapsed = Date.now() - paddleStart;

            if (!paddleData.success) {
                throw new Error(paddleData.error || 'PaddleOCR 실패');
            }

            // 보정 이미지로 전환
            let currentLabels = paddleData.labels;
            if (paddleData.correctedImageUrl) {
                const fullUrl = `${apiBaseUrl}${paddleData.correctedImageUrl}?t=${Date.now()}`;
                setCurrentImageUrl(fullUrl);
                console.log(`🔄 [OCR Pipeline] 보정 이미지로 전환: ${paddleData.correctedImageUrl}`);
            }

            // ⭐ PaddleOCR 결과 즉시 화면에 표시
            setLabels(currentLabels);
            console.log(`✅ [OCR Pipeline] PaddleOCR: ${currentLabels.length}개 박스 (${paddleElapsed}ms)`);
            setLoadedMsg(`✅ PaddleOCR: ${currentLabels.length}개 박스 (${paddleElapsed}ms) - AI 분석 중...`);

            // =============================================
            // Step 2: AI Merge + Gemini 병렬 실행
            // =============================================
            console.log('🔄 [OCR Pipeline] Step 2: AI Merge + Gemini 병렬 실행...');

            const ocrBoxes = currentLabels.map(label => ({
                text: label.text || '',
                bbox: label.bbox
            }));

            // AI Merge 프로미스
            const aiMergePromise = (async () => {
                try {
                    const mergeStart = Date.now();
                    const mergeRes = await fetch(`${apiBaseUrl}/api/ocr/merge-with-llm`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            ocrBoxes: ocrBoxes,
                            templateFields: templateFields
                        })
                    });
                    const mergeData = await mergeRes.json();
                    return {
                        success: mergeData.success,
                        data: mergeData.data,
                        elapsed: Date.now() - mergeStart
                    };
                } catch (err) {
                    console.warn('⚠️ [OCR Pipeline] AI Merge 오류:', err.message);
                    return { success: false, error: err.message };
                }
            })();

            // Gemini 프로미스
            const geminiPromise = (async () => {
                try {
                    const geminiStart = Date.now();
                    const geminiFormData = new FormData();
                    geminiFormData.append('file', file);
                    geminiFormData.append('templateId', templateId);
                    geminiFormData.append('templateFields', JSON.stringify(templateFields));

                    const geminiRes = await fetch(`${apiBaseUrl}/api/ocr/gemini-extract`, {
                        method: 'POST',
                        body: geminiFormData
                    });
                    const geminiData = await geminiRes.json();
                    return {
                        success: geminiData.success,
                        data: geminiData.data,
                        elapsed: Date.now() - geminiStart
                    };
                } catch (err) {
                    console.warn('⚠️ [OCR Pipeline] Gemini 오류:', err.message);
                    return { success: false, error: err.message };
                }
            })();

            // 병렬 실행 결과 대기
            const [aiMergeResult, geminiResult] = await Promise.all([aiMergePromise, geminiPromise]);

            // =============================================
            // Step 3: 결과 적용
            // =============================================

            // AI Merge 결과 적용 (fieldKey + vllmText 역매핑)
            if (aiMergeResult.success && aiMergeResult.data) {
                console.log(`✅ [OCR Pipeline] AI Merge: ${Object.keys(aiMergeResult.data).length}개 필드 (${aiMergeResult.elapsed}ms)`);

                setLabels(prev => {
                    const updated = [...prev];
                    for (const [fieldKey, extractedValue] of Object.entries(aiMergeResult.data)) {
                        if (!extractedValue || typeof extractedValue !== 'string') continue;

                        const normalizedValue = extractedValue.replace(/[\s\-.,·()]/g, '').toLowerCase();

                        for (let i = 0; i < updated.length; i++) {
                            if (updated[i].fieldKey) continue;
                            if (!updated[i].text) continue;

                            const normalizedText = updated[i].text.replace(/[\s\-.,·()]/g, '').toLowerCase();
                            const isMatch = normalizedValue.includes(normalizedText) || normalizedText.includes(normalizedValue);

                            if (isMatch && normalizedText.length >= 2) {
                                updated[i] = {
                                    ...updated[i],
                                    fieldKey: fieldKey,
                                    vllmText: extractedValue,
                                    source: 'ai-merge'
                                };
                                console.log(`✅ [역매핑] "${updated[i].text}" → ${fieldKey}`);
                            }
                        }
                    }
                    return updated;
                });

                setLoadedMsg(`✅ AI Merge: ${Object.keys(aiMergeResult.data).length}개 필드 - Gemini 대기 중...`);
            }

            // Gemini 결과 적용 (geminiText 업데이트 + 없는 필드 생성)
            if (geminiResult.success && geminiResult.data) {
                console.log(`✅ [OCR Pipeline] Gemini: ${Object.keys(geminiResult.data).length}개 필드 (${geminiResult.elapsed}ms)`);

                setLabels(prev => {
                    const updated = [...prev];
                    for (const [fieldKey, value] of Object.entries(geminiResult.data)) {
                        let found = false;
                        for (let i = 0; i < updated.length; i++) {
                            if (updated[i].fieldKey === fieldKey) {
                                updated[i] = { ...updated[i], geminiText: value };
                                found = true;
                            }
                        }
                        // 필드가 없으면 새로 생성
                        if (!found) {
                            const strValue = typeof value === 'string' ? value : String(value || '');
                            updated.unshift({
                                id: `gemini_${fieldKey}_${Date.now()}`,
                                fieldKey: fieldKey,
                                text: strValue,
                                paddleText: '',
                                geminiText: strValue,
                                source: 'gemini',
                                confidence: 0.95
                            });
                        }
                    }
                    return updated;
                });
            }

            // 최종 메시지
            const aiStatus = aiMergeResult.success ? '✓' : '✗';
            const geminiStatus = geminiResult.success ? '✓' : '✗';
            setLoadedMsg(`✅ OCR 완료: ${currentLabels.length}개 박스, AI:${aiStatus}, Gemini:${geminiStatus}`);
            console.log(`🎯 [OCR Pipeline] 완료! PaddleOCR: ${paddleElapsed}ms, AI Merge: ${aiMergeResult.elapsed || 0}ms, Gemini: ${geminiResult.elapsed || 0}ms`);

            setTimeout(() => setLoadedMsg(null), 3000);

        } catch (error) {
            console.error('❌ [OCR Pipeline] 오류:', error);
            setLoadedMsg(`❌ OCR 오류: ${error.message}`);
            alert('OCR 처리 실패: ' + error.message);
        } finally {
            setIsProgressiveProcessing(false);
        }
    };

    // ============ Smart Auto-Labeling ============

    const [isSmartLabeling, setIsSmartLabeling] = useState(false);

    const smartLabel = async () => {
        if (!currentImageUrl || isSmartLabeling) return;

        // ?쒗뵆由??꾨뱶 以?example ?먮뒗 exampleValue媛 ?덈뒗 寃껊쭔 ?꾪꽣留?
        // LLM 異붿텧 寃곌낵??exampleValue????λ맖
        const fieldsWithExample = templateFields
            .map(f => ({
                ...f,
                example: f.example || f.exampleValue || ''
            }))
            .filter(f => f.example && f.example.trim());

        if (fieldsWithExample.length === 0) {
            alert('?쒗뵆由우뿉 ?덉떆(example) 媛믪씠 ?덈뒗 ?꾨뱶媛 ?없뒿?덈떎.\n癒쇱? ?뚯씪???낅줈?쒗븯怨??먮룞 遺꾩꽍???ㅽ뻾?섏뿬 LLM??媛믪쓣 異붿텧?섎룄濡??섏꽭??');
            return;
        }

        setIsSmartLabeling(true);
        try {
            console.log(`?쭬 [?ㅻ쭏???쇰꺼留? ?쒖옉 - ${fieldsWithExample.length}媛??꾨뱶 留ㅼ묶...`);

            // ?대?吏 URL?먯꽌 Blob 媛?몄삤湲?
            const response = await fetch(currentImageUrl);
            const blob = await response.blob();

            // FormData ?앹꽦
            const formData = new FormData();
            formData.append('file', blob, 'image.png');
            formData.append('pageNumber', currentPage.toString());
            formData.append('templateId', templateId || '');  // ⭐ Changed: send templateId for hybrid matching

            // API 호출 - ⭐ Using new smart-extract endpoint with orientation detection
            const result = await fetch(`${apiBaseUrl}/api/ocr/smart-extract`, {
                method: 'POST',
                body: formData
            });

            const data = await result.json();

            if (data.success && data.labels) {
                console.log(`??[?ㅻ쭏???쇰꺼留? ${data.matched}/${data.total}媛?留ㅼ묶 (${data.elapsed}ms)`);

                // ?넅 ?꾩껜 OCR 寃곌낵 諛??먮룞 留ㅼ묶 ???
                if (data.ocrResults && data.ocrResults.length > 0) {
                    setOcrResults(data.ocrResults);
                    setAutoMatches(data.autoMatches || []);
                    setSmartMappingMode(true);
                    console.log(`?뱥 [?ㅻ쭏??留ㅽ븨] ${data.ocrResults.length}媛?OCR 諛뺤뒪, ${data.autoMatches?.length || 0}媛??먮룞 留ㅼ묶`);
                }

                if (data.labels.length > 0) {
                    // ?띿뒪??以묐났 諛⑹? (湲곗〈???숈???꾨뱶 ?덉쑝硫??쒓굅 ??異붽?)
                    setLabels(prev => {
                        const newKeys = new Set(data.labels.map(l => l.fieldKey));
                        const filteredPrev = prev.filter(l => !newKeys.has(l.fieldKey));
                        return [...filteredPrev, ...data.labels];
                    });

                    if (data.unmatchedFields && data.unmatchedFields.length > 0) {
                        console.log('?좑툘 留ㅼ묶 ?ㅽ뙣 ?꾨뱶:', data.unmatchedFields.join(', '));
                    }
                } else {
                    // 留ㅼ묶 ?놁뼱??OCR 寃곌낵???쒖떆
                    if (data.ocrResults && data.ocrResults.length > 0) {
                        console.log('?뱄툘 ?먮룞 留ㅽ븨 ?놁쓬, ?섎룞 留ㅽ븨 紐⑤뱶濡??꾪솚');
                    } else {
                        alert('留ㅼ묶???꾨뱶媛 ?놁뒿?덈떎.\n?대?吏? ?쒗뵆由우쓽 example 媛믪쓣 ?뺤씤?댁＜?몄슂.');
                    }
                }
            } else {
                console.error('???ㅻ쭏???쇰꺼留??ㅽ뙣:', data.error);
                alert('?ㅻ쭏???쇰꺼留??ㅽ뙣: ' + data.error);
            }
        } catch (error) {
            console.error('???ㅻ쭏???쇰꺼留??ㅻ쪟:', error);
            alert('?ㅻ쭏???쇰꺼留??ㅻ쪟: ' + error.message);
        } finally {
            setIsSmartLabeling(false);
        }
    };

    // ?넅 OCR 諛뺤뒪 ?좏깮 ?좉? (Ctrl+?대┃?쇰줈 ?ㅼ쨷 ?좏깮)
    const toggleOcrSelection = (ocrId, isCtrlPressed) => {
        if (isCtrlPressed) {
            setSelectedOcrIds(prev =>
                prev.includes(ocrId)
                    ? prev.filter(id => id !== ocrId)
                    : [...prev, ocrId]
            );
        } else {
            setSelectedOcrIds(prev =>
                prev.includes(ocrId) && prev.length === 1
                    ? []
                    : [ocrId]
            );
        }
    };

    // ?넅 ?좏깮??OCR 諛뺤뒪?ㅼ쓣 ?꾨뱶??留ㅽ븨
    const mapOcrToField = (fieldKey) => {
        if (selectedOcrIds.length === 0) return;

        const selectedBoxes = ocrResults.filter(o => selectedOcrIds.includes(o.id));
        if (selectedBoxes.length === 0) return;

        // ?띿뒪??寃고빀 (ID ?쒖꽌?濡?
        const sortedBoxes = [...selectedBoxes].sort((a, b) => a.id - b.id);
        const mergedText = sortedBoxes.map(b => b.text).join(' ');

        // bbox 蹂묓빀 (?⑹쭛??
        const minX = Math.min(...sortedBoxes.map(b => b.bbox.x));
        const minY = Math.min(...sortedBoxes.map(b => b.bbox.y));
        const maxX = Math.max(...sortedBoxes.map(b => b.bbox.x + b.bbox.width));
        const maxY = Math.max(...sortedBoxes.map(b => b.bbox.y + b.bbox.height));

        const newLabel = {
            id: `mapped_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
            fieldKey,
            text: mergedText,
            bbox: {
                x: minX,
                y: minY,
                width: maxX - minX,
                height: maxY - minY
            },
            confidence: sortedBoxes.reduce((sum, b) => sum + b.confidence, 0) / sortedBoxes.length,
            mergedFrom: sortedBoxes.map(b => b.id),
            pageNumber: currentPage
        };

        // 湲곗〈 媛숈? ?꾨뱶 ?쇰꺼 ?쒓굅 ??異붽?
        setLabels(prev => [
            ...prev.filter(l => l.fieldKey !== fieldKey),
            newLabel
        ]);

        console.log(`??[?섎룞 留ㅽ븨] "${fieldKey}" ??[${sortedBoxes.map(b => b.id).join(',')}] = "${mergedText}"`);
        setSelectedOcrIds([]);
        setMappingTarget(null);
    };

    // ?넅 ?ㅻ쭏??留ㅽ븨 紐⑤뱶 醫낅즺
    const exitSmartMappingMode = () => {
        setSmartMappingMode(false);
        setOcrResults([]);
        setAutoMatches([]);
        setSelectedOcrIds([]);
        setMappingTarget(null);
    };

    // ============ Re-Recognition ============

    const [isReRecognizing, setIsReRecognizing] = useState(false);

    const reRecognize = async (labelId, overrideBbox = null) => {
        if (!imageUrl || isReRecognizing) return;

        const label = labels.find(l => l.id === labelId);
        if (!label) return;

        // Use override bbox if provided (for real-time updates)
        const targetBbox = overrideBbox || label.bbox;

        setIsReRecognizing(true);
        try {
            console.log('🔄 [Re-Recognize] Starting...', targetBbox);

            // Fetch image blob
            const response = await fetch(imageUrl);
            const blob = await response.blob();

            // FormData 생성 (크롭 좌표 포함)
            const formData = new FormData();
            formData.append('file', blob, 'image.png');
            formData.append('cropX', Math.round(targetBbox.x).toString());
            formData.append('cropY', Math.round(targetBbox.y).toString());
            formData.append('cropWidth', Math.round(targetBbox.width).toString());
            formData.append('cropHeight', Math.round(targetBbox.height).toString());

            // API ?몄텧
            const result = await fetch(`${apiBaseUrl}/api/ocr/re-recognize`, {
                method: 'POST',
                body: formData
            });

            const data = await result.json();

            if (data.success && data.text) {
                console.log(`??[?ъ씤?? ?꾨즺: "${data.text}"`);
                // ?쇰꺼???띿뒪???낅뜲?댄듃
                setLabels(prev => prev.map(l =>
                    l.id === labelId ? { ...l, text: data.text, confidence: data.confidence } : l
                ));
            } else {
                console.error('???ъ씤???ㅽ뙣:', data.error);
                alert('?ъ씤???ㅽ뙣: ' + (data.error || '?띿뒪?몃? ?몄떇?????놁뒿?덈떎.'));
            }
        } catch (error) {
            console.error('???ъ씤???ㅻ쪟:', error);
            alert('?ъ씤???ㅻ쪟: ' + error.message);
        } finally {
            setIsReRecognizing(false);
        }
    };

    // ============ Render ============

    const selectedLabel = labels.find(l => l.id === selectedId);

    // ============ UI Render Helpers ============

    // 1. Left Navigation
    const renderLeftNav = () => (
        <div className="w-[60px] bg-white border-r border-[#DADCE0] flex flex-col items-center py-4 gap-4 z-10 flex-shrink-0">
            <div className="p-2 rounded-lg bg-blue-50 text-blue-600">
                <Layout className="w-6 h-6" />
            </div>
            <div className="flex-1 w-full px-2 overflow-y-auto space-y-2 scrollbar-none">
                {Array.from({ length: totalPages }).map((_, i) => (
                    <button
                        key={i}
                        onClick={() => onPageChange && onPageChange(i + 1)}
                        className={`w-full aspect-square rounded flex items-center justify-center text-xs font-semibold transition ${currentPage === i + 1
                            ? 'bg-blue-600 text-white shadow-md'
                            : 'bg-white border border-gray-200 text-gray-500 hover:border-blue-400 hover:text-blue-500'
                            }`}
                        title={`Page ${i + 1}`}
                    >
                        {i + 1}
                    </button>
                ))}
            </div>
        </div>
    );

    // 2. Floating Toolbar
    const renderToolbar = () => (
        <div className="absolute top-4 left-1/2 -translate-x-1/2 bg-white rounded-lg shadow-[0_2px_8px_rgba(0,0,0,0.15)] border border-[#DADCE0] p-1 flex items-center gap-1 z-30 transition-all hover:shadow-[0_4px_12px_rgba(0,0,0,0.2)]">
            <button onClick={() => setTool('select')} className={`p-2 rounded ${tool === 'select' ? 'bg-blue-50 text-blue-700' : 'hover:bg-gray-100 text-[#5F6368]'}`} title="선택 (V)">
                <MousePointer className="w-5 h-5" />
            </button>
            <button onClick={() => setTool('draw')} className={`p-2 rounded ${tool === 'draw' ? 'bg-blue-50 text-blue-700' : 'hover:bg-gray-100 text-[#5F6368]'}`} title="박스 그리기 (W)">
                <Square className="w-5 h-5" />
            </button>
            <div className="w-px h-5 bg-[#DADCE0] mx-1" />

            <button onClick={undo} className="p-2 hover:bg-gray-100 rounded text-[#5F6368]" title="실행 취소 (Ctrl+Z)"><ChevronLeft className="w-5 h-5" /></button>
            <button onClick={redo} className="p-2 hover:bg-gray-100 rounded text-[#5F6368]" title="다시 실행 (Ctrl+Y)"><ChevronRight className="w-5 h-5" /></button>

            <div className="w-px h-5 bg-[#DADCE0] mx-1" />

            <button onClick={zoomOut} className="p-2 hover:bg-gray-100 rounded text-[#5F6368]" title="축소"><ZoomOut className="w-5 h-5" /></button>
            <span className="text-xs font-mono w-10 text-center font-medium text-[#202124]">{Math.round(scale * 100)}%</span>
            <button onClick={zoomIn} className="p-2 hover:bg-gray-100 rounded text-[#5F6368]" title="확대"><ZoomIn className="w-5 h-5" /></button>

            <div className="w-px h-5 bg-[#DADCE0] mx-1" />

            <button onClick={() => setShowGrid(!showGrid)} className={`p-2 rounded ${showGrid ? 'bg-blue-50 text-blue-700' : 'hover:bg-gray-100 text-[#5F6368]'}`} title="그리드 (G)">
                <Grid className="w-5 h-5" />
            </button>

            <button
                onClick={smartLabel}
                className={`p-2 rounded flex items-center gap-2 ${smartMappingMode ? 'bg-purple-100 text-purple-700 ring-2 ring-purple-500 ring-inset' : 'hover:bg-gray-100 text-[#5F6368]'}`}
                title="스마트 매핑 모드"
            >
                {isSmartLabeling ? (
                    <RefreshCw className="w-5 h-5 animate-spin text-purple-500" />
                ) : (
                    smartMappingMode ? <Layers className="w-5 h-5" /> : <Target className="w-5 h-5" />
                )}
            </button>
        </div>
    );

    // 3. Right Data Panel
    const renderRightPanel = () => {
        return (
            <div
                className="bg-white border-l border-[#DADCE0] flex flex-col z-20 shadow-[-4px_0_16px_rgba(0,0,0,0.05)] relative"
                style={{ width: `${panelWidth}px` }}
            >
                {/* Resize Handle - Left Edge */}
                <div
                    className="absolute left-0 top-0 bottom-0 w-2 bg-gray-200 hover:bg-blue-400 cursor-col-resize transition-colors z-30"
                    onMouseDown={(e) => {
                        e.preventDefault();
                        const startX = e.clientX;
                        const startWidth = panelWidth;

                        const handleMouseMove = (moveEvent) => {
                            const delta = startX - moveEvent.clientX;
                            const newWidth = Math.max(400, Math.min(1000, startWidth + delta));
                            setPanelWidth(newWidth);
                        };

                        const handleMouseUp = () => {
                            document.removeEventListener('mousemove', handleMouseMove);
                            document.removeEventListener('mouseup', handleMouseUp);
                            document.body.style.cursor = '';
                            document.body.style.userSelect = '';
                        };

                        document.addEventListener('mousemove', handleMouseMove);
                        document.addEventListener('mouseup', handleMouseUp);
                        document.body.style.cursor = 'col-resize';
                        document.body.style.userSelect = 'none';
                    }}
                    title="Drag to resize"
                >
                    <div className="absolute inset-y-0 left-0 right-0 flex items-center justify-center">
                        <div className="w-0.5 h-8 bg-gray-400 rounded-full" />
                    </div>
                </div>
                {/* Panel Header (Tabs) */}
                <div className="h-10 border-b border-[#DADCE0] flex items-center bg-[#F8F9FA] shrink-0">
                    <button
                        onClick={() => setActiveTab('results')}
                        className={`flex-1 min-w-0 h-full flex items-center justify-center gap-1.5 text-xs font-medium transition-colors border-b-2 px-2 whitespace-nowrap
                            ${activeTab === 'results' ? 'border-blue-500 text-blue-600 bg-white' : 'border-transparent text-gray-500 hover:bg-gray-100'}
                        `}
                    >
                        <List className="w-4 h-4 shrink-0" /> <span className="truncate">Fields ({labels.length})</span>
                    </button>
                    <button
                        onClick={() => setActiveTab('learning')}
                        className={`flex-1 min-w-0 h-full flex items-center justify-center gap-1.5 text-xs font-medium transition-colors border-b-2 px-2 whitespace-nowrap
                            ${activeTab === 'learning' ? 'border-purple-500 text-purple-600 bg-white' : 'border-transparent text-gray-500 hover:bg-gray-100'}
                        `}
                    >
                        <GraduationCap className="w-4 h-4 shrink-0" /> <span className="truncate">Learning Data</span>
                    </button>
                    <button
                        onClick={() => setActiveTab('training')}
                        className={`flex-1 min-w-0 h-full flex items-center justify-center gap-1.5 text-xs font-medium transition-colors border-b-2 px-2 whitespace-nowrap
                            ${activeTab === 'training' ? 'border-green-600 text-green-700 bg-white' : 'border-transparent text-gray-500 hover:bg-gray-100'}
                        `}
                    >
                        <Zap className="w-4 h-4 shrink-0" /> <span className="truncate">Training</span>
                    </button>
                </div>

                {activeTab === 'learning' ? (
                    <LearningPanel
                        ocrResults={ocrResults}
                        imagePath={savedImagePath}
                        imageUrl={imageUrl}
                        fileName={fileName} // 🏷️ Pass to LearningPanel
                        apiBaseUrl={apiBaseUrl}
                        geminiFields={labels}
                        onHighlight={(id) => {
                            setLearningSelectedId(id);
                        }}
                        externalSelectedId={learningSelectedId}
                    />
                ) : activeTab === 'training' ? (
                    <TrainingDataPanel
                        apiBaseUrl={apiBaseUrl}
                        onSelectImage={handleSwitchImage}
                    />
                ) : (
                    <div className="flex flex-col h-full">
                        {/* Top: Labels Grid */}
                        <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
                            <div className="h-8 border-b border-[#DADCE0] flex items-center justify-between px-4 bg-[#F8F9FA] shrink-0">
                                <div className="flex items-center gap-2">
                                    {/* 🤖 vLLM 필드 병합 버튼 */}
                                    <button
                                        onClick={handleMergeWithLLM}
                                        disabled={labels.length === 0 || templateFields.length === 0}
                                        title="vLLM으로 파편화된 OCR 결과를 템플릿 필드에 맞게 병합"
                                        className={`text-xs px-2 py-1 rounded border flex items-center gap-1 transition
                                            ${labels.length > 0 && templateFields.length > 0
                                                ? 'bg-purple-50 border-purple-200 text-purple-700 hover:bg-purple-100'
                                                : 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed'
                                            }`}
                                    >
                                        <BrainCircuit className="w-3 h-3" />
                                        AI 병합
                                    </button>

                                    {/* 🔮 Gemini Ground Truth 버튼 */}
                                    <button
                                        onClick={handleGeminiExtract}
                                        disabled={!currentImageUrl}
                                        title="Gemini로 정답지 추출 (Ground Truth)"
                                        className={`text-xs px-2 py-1 rounded border flex items-center gap-1 transition
                                            ${currentImageUrl
                                                ? 'bg-blue-50 border-blue-200 text-blue-700 hover:bg-blue-100'
                                                : 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed'
                                            }`}
                                    >
                                        <Sparkles className="w-3 h-3" />
                                        Gemini
                                    </button>
                                </div>
                                <div className="flex items-center gap-2">
                                    {smartMappingMode && (
                                        <button onClick={exitSmartMappingMode} className="text-xs px-2 py-1 bg-white border border-[#DADCE0] rounded hover:bg-red-50 hover:text-red-600 hover:border-red-200 transition">
                                            종료
                                        </button>
                                    )}
                                </div>
                            </div>

                            {/* Smart Mapping: Unassigned Items */}
                            {smartMappingMode && (
                                <div className="flex-shrink-0 bg-purple-50 border-b border-purple-100 p-3 max-h-[200px] overflow-y-auto">
                                    <div className="flex items-center justify-between mb-2">
                                        <span className="text-xs font-bold text-purple-800 flex items-center gap-1">
                                            <Target className="w-3 h-3" /> Pending ({ocrResults.filter(o => !o.matched).length})
                                        </span>
                                        <span className="text-[10px] text-purple-600">Select box then click field</span>
                                    </div>

                                    {selectedOcrIds.length > 0 && (
                                        <div className="mb-2 p-2 bg-white rounded border border-purple-200 shadow-sm">
                                            <div className="text-xs text-purple-600 mb-1">Selected: {selectedOcrIds.length}</div>
                                            <div className="text-sm font-medium text-gray-800 truncate">
                                                "{ocrResults.filter(o => selectedOcrIds.includes(o.id)).map(o => o.text).join(' ')}"
                                            </div>
                                        </div>
                                    )}

                                    <div className="flex flex-wrap gap-1">
                                        {ocrResults.filter(o => !o.matched).map(ocr => (
                                            <button
                                                key={ocr.id}
                                                onClick={(e) => toggleOcrSelection(ocr.id, e.ctrlKey || e.metaKey)}
                                                className={`text-[10px] px-1.5 py-0.5 rounded border transition ${selectedOcrIds.includes(ocr.id)
                                                    ? 'bg-blue-600 text-white border-blue-600'
                                                    : 'bg-white border-gray-300 text-gray-600 hover:border-gray-400'
                                                    }`}
                                            >
                                                {ocr.text}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* Data Grid Header */}
                            <div className="flex items-center text-xs font-semibold text-[#5F6368] border-b border-[#DADCE0] w-full bg-[#F8F9FA] sticky top-0">
                                <div className="w-8 px-2 py-2 border-r border-[#EFEFEF] text-center">#</div>
                                <div className="w-[100px] px-3 py-2 border-r border-[#EFEFEF]">Field</div>
                                <div className="flex-1 px-3 py-2 border-r border-[#EFEFEF] text-purple-600">PaddleOCR(AI병합)</div>
                                <div className="flex-1 px-3 py-2 border-r border-[#EFEFEF] text-blue-600">Gemini 3.0</div>
                                <div className="w-8 px-1 py-2 text-center">⚠️</div>
                            </div>

                            {/* Data Grid Rows */}
                            <div className="flex-1 overflow-y-auto bg-white">
                                {/* Template Fields */}
                                {templateFields.map((field, idx) => {
                                    const fieldKey = field.key || field.fieldKey || field.name;
                                    const displayName = field.displayName || field.label || fieldKey;
                                    const matchedLabel = labels.find(l => l.fieldKey === fieldKey);
                                    const paddleText = matchedLabel?.paddleText || matchedLabel?.text || '';
                                    const vllmText = matchedLabel?.text || '';
                                    const geminiText = matchedLabel?.geminiText || '';
                                    const hasDifference = vllmText && geminiText && vllmText !== geminiText;
                                    const isEditing = editingId === `field-${fieldKey}`;

                                    return (
                                        <div
                                            key={`field-${fieldKey}`}
                                            onClick={() => {
                                                if (smartMappingMode && selectedOcrIds.length > 0) {
                                                    mapOcrToField(fieldKey);
                                                } else if (!isEditing) {
                                                    // ⭐ 동일 fieldKey를 가진 모든 박스 찾기 (다중 선택)
                                                    const matchedLabels = labels.filter(l => l.fieldKey === fieldKey && l.bbox);

                                                    if (matchedLabels.length > 0) {
                                                        const ids = matchedLabels.map(l => l.id);
                                                        console.log(`✅ [fieldKey] 다중 매칭 (${fieldKey}): ${matchedLabels.length}개 박스`);
                                                        setSelectedId(ids[0]);  // 첫 번째 선택
                                                        setSelectedIds(ids);    // 모든 박스 선택
                                                        return;
                                                    }

                                                    // ⚠️ 2. fieldKey 매칭 실패시 유사도 fallback
                                                    // 📊 Levenshtein 유사도 계산 함수
                                                    const levenshteinDistance = (a, b) => {
                                                        const matrix = Array(b.length + 1).fill(null).map(() => Array(a.length + 1).fill(null));
                                                        for (let i = 0; i <= a.length; i++) matrix[0][i] = i;
                                                        for (let j = 0; j <= b.length; j++) matrix[j][0] = j;
                                                        for (let j = 1; j <= b.length; j++) {
                                                            for (let i = 1; i <= a.length; i++) {
                                                                const cost = a[i - 1] === b[j - 1] ? 0 : 1;
                                                                matrix[j][i] = Math.min(
                                                                    matrix[j][i - 1] + 1,
                                                                    matrix[j - 1][i] + 1,
                                                                    matrix[j - 1][i - 1] + cost
                                                                );
                                                            }
                                                        }
                                                        return matrix[b.length][a.length];
                                                    };

                                                    const similarity = (a, b) => {
                                                        if (!a || !b) return 0;
                                                        const maxLen = Math.max(a.length, b.length);
                                                        if (maxLen === 0) return 1;
                                                        return 1 - (levenshteinDistance(a, b) / maxLen);
                                                    };

                                                    // 필드 텍스트와 매칭되는 모든 bbox 찾기
                                                    const searchText = vllmText || geminiText || paddleText;

                                                    if (searchText) {
                                                        // 정규화 함수들
                                                        const normalizeText = (text) => text.replace(/[\s\-.,·]/g, '').toLowerCase();
                                                        const extractNumbers = (text) => text.replace(/[^0-9]/g, '');
                                                        const normalizedSearch = normalizeText(searchText);
                                                        const searchNumbers = extractNumbers(searchText);

                                                        // 검색어를 단어로 분리 (2글자 이상)
                                                        const searchParts = searchText.split(/[\s,\-·]+/).filter(s => s.length >= 2);

                                                        // 🎯 각 라벨에 대해 유사도 점수 계산
                                                        // (fieldKey 기반 매칭이 우선, 없으면 유사도 fallback)
                                                        const scoredLabels = labels
                                                            .filter(l => l.bbox && l.text && l.text.trim().length >= 2)
                                                            .map(l => {
                                                                const labelText = l.text.trim();
                                                                const normalizedLabel = normalizeText(labelText);
                                                                const labelNumbers = extractNumbers(labelText);

                                                                let maxScore = 0;
                                                                let matchReason = '';

                                                                // 1. 전체 텍스트 유사도 (정규화)
                                                                const fullSim = similarity(normalizedSearch, normalizedLabel);
                                                                if (fullSim > maxScore) { maxScore = fullSim; matchReason = 'full'; }

                                                                // 2. 라벨이 검색어에 포함 (70%+)
                                                                if (normalizedSearch.includes(normalizedLabel) && normalizedLabel.length >= 2) {
                                                                    const score = 0.9; // 포함되면 90%
                                                                    if (score > maxScore) { maxScore = score; matchReason = 'contains'; }
                                                                }

                                                                // 3. 숫자 유사도 (주민등록번호 등) - 90% 이상일 때만 매칭
                                                                if (searchNumbers.length >= 6 && labelNumbers.length >= 4) {
                                                                    const numSim = similarity(searchNumbers, labelNumbers);
                                                                    // 숫자는 엄격하게 90% 이상 유사해야 매칭
                                                                    if (numSim >= 0.90 && numSim > maxScore) {
                                                                        maxScore = numSim;
                                                                        matchReason = 'numbers';
                                                                    }
                                                                }

                                                                // 4. 각 검색어 부분과 비교
                                                                for (const part of searchParts) {
                                                                    const normalizedPart = normalizeText(part);
                                                                    if (normalizedPart.length >= 2) {
                                                                        // 부분 포함 (숫자로만 구성된 경우 제외 - 오매칭 방지)
                                                                        const isPartNumeric = /^\d+$/.test(normalizedPart);
                                                                        const isLabelNumeric = /^\d+$/.test(normalizedLabel);
                                                                        if (!isPartNumeric && !isLabelNumeric) {
                                                                            // 일반 텍스트: 포함 체크 (최소 3자 이상만)
                                                                            if (normalizedLabel.length >= 3 && normalizedPart.length >= 3) {
                                                                                if (normalizedLabel.includes(normalizedPart) || normalizedPart.includes(normalizedLabel)) {
                                                                                    const score = 0.85;
                                                                                    if (score > maxScore) { maxScore = score; matchReason = 'part-contains'; }
                                                                                }
                                                                            }
                                                                        }
                                                                        // 부분 유사도 (숫자면 90%, 일반 70%)
                                                                        const partSim = similarity(normalizedPart, normalizedLabel);
                                                                        const partThreshold = (isPartNumeric && isLabelNumeric) ? 0.90 : 0.70;
                                                                        if (partSim >= partThreshold && partSim > maxScore) {
                                                                            maxScore = partSim;
                                                                            matchReason = 'part-sim';
                                                                        }
                                                                    }
                                                                }

                                                                // 5. 라벨의 각 단어와 검색어 비교
                                                                const labelParts = labelText.split(/[\s,\-·]+/).filter(s => s.length >= 2);
                                                                for (const lPart of labelParts) {
                                                                    const normalizedLPart = normalizeText(lPart);
                                                                    if (normalizedSearch.includes(normalizedLPart) && normalizedLPart.length >= 2) {
                                                                        const score = 0.85;
                                                                        if (score > maxScore) { maxScore = score; matchReason = 'label-part'; }
                                                                    }
                                                                    // 각 검색어 부분과 유사도
                                                                    for (const sPart of searchParts) {
                                                                        const normalizedSPart = normalizeText(sPart);
                                                                        const partSim = similarity(normalizedSPart, normalizedLPart);
                                                                        // 숫자로만 구성된 경우 90% 이상만 매칭 (오매칭 방지)
                                                                        const isNumericOnly = /^\d+$/.test(normalizedSPart) && /^\d+$/.test(normalizedLPart);
                                                                        const threshold = isNumericOnly ? 0.90 : 0.70;
                                                                        if (partSim >= threshold && partSim > maxScore) {
                                                                            maxScore = partSim;
                                                                            matchReason = 'word-sim';
                                                                        }
                                                                    }
                                                                }

                                                                return { label: l, score: maxScore, reason: matchReason };
                                                            });

                                                        // 🎯 범용 로직: 필드 특성에 따라 단일/다중 선택 결정
                                                        const isNumericSearch = searchNumbers.length > normalizedSearch.length * 0.5;
                                                        const SIMILARITY_THRESHOLD = isNumericSearch ? 0.85 : 0.70;

                                                        // 필드 복잡도 판단: 긴 텍스트(20자+) 또는 구분자(공백,콤마) 2개 이상 → 다중 bbox 허용
                                                        const separatorCount = (searchText.match(/[\s,·]+/g) || []).length;
                                                        const isComplexField = searchText.length >= 20 || separatorCount >= 2;

                                                        let matchingLabels = scoredLabels
                                                            .filter(s => s.score >= SIMILARITY_THRESHOLD)
                                                            .sort((a, b) => b.score - a.score);

                                                        // 단순 필드: 최고 점수 1개만 선택
                                                        if (!isComplexField && matchingLabels.length > 1) {
                                                            matchingLabels = [matchingLabels[0]];
                                                        }

                                                        if (matchingLabels.length > 0) {
                                                            const matchedIds = matchingLabels.map(s => s.label.id);
                                                            const mode = isComplexField ? '다중' : '단일';
                                                            console.log(`🎯 [${mode}] 매칭 (${fieldKey}, ${searchText.length}자, 구분자${separatorCount}개):`,
                                                                matchingLabels.map(s => `${s.label.text}(${(s.score * 100).toFixed(0)}%)`));
                                                            setSelectedIds(matchedIds);
                                                            setSelectedId(matchedIds[0]);
                                                            return;
                                                        }
                                                    }

                                                    // fieldKey 매칭도 없고 유사도 매칭도 없을 때
                                                    console.log(`⚠️ 매칭 없음 (${fieldKey})`);
                                                }
                                            }}
                                            className={`group flex items-center border-b border-[#F1F3F4] text-xs h-8 transition cursor-pointer
                                                ${matchedLabel && selectedId === matchedLabel.id ? 'bg-[#E8F0FE]' : 'hover:bg-gray-50'}
                                                ${hasDifference ? 'bg-red-50' : ''}`}
                                        >
                                            <div className="w-8 px-2 py-1.5 border-r border-[#F1F3F4] text-gray-500 text-center font-medium">{idx + 1}</div>
                                            <div className="w-[100px] px-3 py-1.5 border-r border-[#F1F3F4] text-gray-600 truncate font-medium" title={displayName}>
                                                {displayName}
                                            </div>
                                            {/* PaddleOCR+vLLM Column - 클릭시 해당 값 사용 */}
                                            <div
                                                className={`flex-1 px-3 py-1.5 border-r border-[#F1F3F4] truncate ${hasDifference ? 'cursor-pointer hover:bg-purple-50' : ''}`}
                                                title={hasDifference ? `클릭하면 vLLM 값 사용` : (vllmText || paddleText)}
                                                onClick={(e) => {
                                                    if (hasDifference) {
                                                        e.stopPropagation();
                                                        // vLLM 값을 최종값으로 확정 (geminiText 삭제)
                                                        setLabels(prev => prev.map(l =>
                                                            l.fieldKey === fieldKey
                                                                ? { ...l, geminiText: vllmText }
                                                                : l
                                                        ));
                                                        setLoadedMsg(`✅ "${fieldKey}" vLLM 값 확정`);
                                                        setTimeout(() => setLoadedMsg(null), 2000);
                                                    }
                                                }}
                                            >
                                                {renderDiffText(vllmText || paddleText, geminiText)}
                                                {hasDifference && <span className="ml-1 text-[10px] text-purple-600">✓</span>}
                                            </div>
                                            {/* Gemini Column - 클릭시 적용, 더블클릭시 편집 */}
                                            <div
                                                className={`flex-1 px-3 py-1.5 border-r border-[#F1F3F4] ${isEditing ? '' : 'truncate'} ${hasDifference ? 'cursor-pointer hover:bg-green-50' : 'hover:bg-blue-50 cursor-text'}`}
                                                title="더블클릭하여 수정"
                                                onClick={(e) => {
                                                    if (!isEditing && hasDifference && geminiText) {
                                                        e.stopPropagation();
                                                        setLabels(prev => prev.map(l =>
                                                            l.fieldKey === fieldKey
                                                                ? { ...l, text: geminiText }
                                                                : l
                                                        ));
                                                        setLoadedMsg(`✅ "${fieldKey}" Gemini 값 적용`);
                                                        setTimeout(() => setLoadedMsg(null), 2000);
                                                    }
                                                }}
                                                onDoubleClick={(e) => {
                                                    e.stopPropagation();
                                                    setEditingId(`field-${fieldKey}`);
                                                    setEditText(geminiText || vllmText || paddleText || '');
                                                }}
                                            >
                                                {isEditing ? (
                                                    <input
                                                        type="text"
                                                        value={editText}
                                                        onChange={(e) => setEditText(e.target.value)}
                                                        onBlur={() => {
                                                            // 저장하고 편집 종료
                                                            setLabels(prev => prev.map(l =>
                                                                l.fieldKey === fieldKey
                                                                    ? { ...l, text: editText, geminiText: editText }
                                                                    : l
                                                            ));
                                                            setEditingId(null);
                                                            setLoadedMsg(`✅ "${fieldKey}" 수정 완료`);
                                                            setTimeout(() => setLoadedMsg(null), 2000);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                e.target.blur();
                                                            } else if (e.key === 'Escape') {
                                                                setEditingId(null);
                                                            }
                                                        }}
                                                        autoFocus
                                                        className="w-full px-1 py-0.5 text-xs border border-blue-400 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                                                    />
                                                ) : (
                                                    <>
                                                        {renderDiffText(geminiText, vllmText || paddleText)}
                                                        {hasDifference && geminiText && (
                                                            <span className="ml-1 text-[10px] text-green-600 font-medium">✓ 적용</span>
                                                        )}
                                                        {!geminiText && !hasDifference && (
                                                            <span className="text-gray-400 text-[10px]">더블클릭 수정</span>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                            <div className="w-8 px-1 py-1.5 text-center">
                                                {hasDifference && <AlertCircle className="w-4 h-4 text-red-500 mx-auto" />}
                                            </div>
                                        </div>
                                    );
                                })}

                                {/* PaddleOCR Detection Results */}
                                {labels.filter(label => label.bbox).map((label, index) => {
                                    const isSelected = selectedId === label.id;
                                    // Smart Mapping Mode에서 OCR 박스가 선택되어 있으면 '덮어쓰기' 가능하도록 스타일 및 핸들러 추가
                                    const isOverwritable = smartMappingMode && selectedOcrIds.length > 0;
                                    const isEditing = editingId === label.id;

                                    return (
                                        <div
                                            key={label.id}
                                            onClick={() => {
                                                if (isOverwritable) {
                                                    if (window.confirm(`Override value of '${label.fieldKey}' with selected text?`)) {
                                                        mapOcrToField(label.fieldKey);
                                                    }
                                                } else {
                                                    setSelectedId(label.id);
                                                }
                                            }}
                                            className={`group flex items-center border-b border-[#F1F3F4] text-xs h-8 transition cursor-pointer 
                                    ${isSelected ? 'bg-[#E8F0FE]' : 'hover:bg-[#F8F9FA]'}
                                    ${isOverwritable ? 'hover:bg-purple-50 hover:border-purple-200' : ''}
                                `}
                                        >
                                            <div className="w-8 px-2 py-1.5 border-r border-[#F1F3F4] text-gray-500 text-center text-xs font-medium">{index + 1}</div>
                                            <div
                                                className="w-[100px] px-3 py-1.5 border-r border-[#F1F3F4] truncate font-medium text-[#202124] flex items-center gap-1 shrink-0 relative group/field cursor-pointer hover:bg-blue-50"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setEditingFieldId(editingFieldId === label.id ? null : label.id);
                                                }}
                                            >
                                                <div className={`w-1.5 h-1.5 rounded-full ${label.fieldKey ? 'bg-green-500' : 'bg-gray-500'}`} />
                                                {label.fieldKey || <span className="text-gray-500">Unassigned</span>}
                                                <span className="ml-auto text-gray-400 opacity-0 group-hover/field:opacity-100">▼</span>

                                                {/* Field 변경 드롭다운 */}
                                                {editingFieldId === label.id && (
                                                    <div
                                                        className="absolute top-full left-0 z-50 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg py-1 min-w-[150px] max-h-[200px] overflow-y-auto"
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        <div
                                                            className="px-3 py-1.5 hover:bg-gray-50 cursor-pointer text-gray-500 text-xs"
                                                            onClick={() => {
                                                                setLabels(prev => prev.map(l =>
                                                                    l.id === label.id ? { ...l, fieldKey: null, source: 'manual' } : l
                                                                ));
                                                                setEditingFieldId(null);
                                                            }}
                                                        >
                                                            ⭕ Unassigned
                                                        </div>
                                                        {templateFields.map((field, i) => {
                                                            const fk = field.key || field.fieldKey || field.name;
                                                            return (
                                                                <div
                                                                    key={i}
                                                                    className={`px-3 py-1.5 hover:bg-blue-50 cursor-pointer text-xs ${label.fieldKey === fk ? 'bg-blue-100 text-blue-700' : 'text-gray-700'}`}
                                                                    onClick={() => {
                                                                        setLabels(prev => prev.map(l =>
                                                                            l.id === label.id ? { ...l, fieldKey: fk, source: 'manual' } : l
                                                                        ));
                                                                        setEditingFieldId(null);
                                                                        console.log(`🔧 [수동 변경] "${label.text}" → ${fk}`);
                                                                    }}
                                                                >
                                                                    ✓ {fk}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>

                                            {/* Paddle Column (Left) */}
                                            <div className="flex-1 px-3 py-1.5 border-r border-[#F1F3F4] min-w-0" title={label.paddleText || label.text}>
                                                <span className="truncate w-full block text-gray-600">
                                                    {label.paddleText || (label.isSmartLabel ? '-' : label.text)}
                                                </span>
                                            </div>

                                            {/* Gemini Column (Right, Editable) */}
                                            <div className="flex-1 px-3 py-1.5 border-r border-[#F1F3F4] min-w-0 group/value relative">
                                                {isEditing ? (
                                                    <input
                                                        type="text"
                                                        value={editText}
                                                        onChange={(e) => setEditText(e.target.value)}
                                                        onKeyDown={(e) => handleEditKeyDown(e, label.id)}
                                                        onBlur={() => handleEditSave(label.id)}
                                                        autoFocus
                                                        className="w-full text-xs p-1 border rounded focus:outline-none focus:border-blue-500"
                                                    />
                                                ) : (
                                                    <div
                                                        className="relative text-[#202124] hover:text-blue-600 cursor-text h-full flex items-center pr-4"
                                                        title={label.geminiText || ''}
                                                        onDoubleClick={() => handleEditStart(label)}
                                                    >
                                                        <span className={`truncate w-full block ${label.isSmartLabel ? 'text-blue-700 font-medium' : ''}`}>
                                                            {label.geminiText || ''}
                                                        </span>

                                                        {isOverwritable && (
                                                            <div className="absolute inset-0 bg-purple-50/90 flex items-center px-2 text-purple-700 text-xs font-medium opacity-0 group-hover:opacity-100 pointer-events-none">
                                                                Overwrite?
                                                            </div>
                                                        )}
                                                        <div className="absolute right-0 opacity-0 group-hover:opacity-100 cursor-text">
                                                            <span className="text-[10px] text-gray-400">✎</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="w-[50px] px-1 py-1.5 text-xs text-center text-gray-500 truncate">
                                                {label.confidence ? Math.round(label.confidence * 100) + '%' : '-'}
                                            </div>
                                        </div >
                                    );
                                })}
                            </div >
                        </div>

                        {/* Bottom: Detection Box Position */}
                        <div className="h-[120px] border-t border-[#DADCE0] bg-white flex flex-col shrink-0">
                            <div className="px-3 py-1 bg-[#F3F4F6] border-b border-[#DADCE0] text-[10px] font-bold text-[#5F6368] flex items-center justify-between shrink-0">
                                <span>Detection Box Position ({labels.filter(l => l.bbox).length})</span>
                            </div>
                            <div className="flex-1 overflow-y-auto">
                                {labels.filter(label => label.bbox).map((label, idx) => {
                                    const isSelected = selectedId === label.id;
                                    // Calculate 4 points from bbox
                                    const { x, y, width, height } = label.bbox;
                                    const x1 = Math.round(x);
                                    const y1 = Math.round(y);
                                    const x2 = Math.round(x + width);
                                    const y2 = Math.round(y + height);
                                    const pointsStr = `[(${x1}, ${y1}), (${x2}, ${y1}), (${x2}, ${y2}), (${x1}, ${y2})]`;

                                    return (
                                        <div
                                            key={label.id}
                                            ref={el => rowRefs.current[label.id] = el}
                                            onClick={() => setSelectedId(label.id)}
                                            className={`px-2 py-0.5 border-b border-[#F1F3F4] text-[10px] font-mono cursor-pointer transition-colors flex gap-1
                                                ${isSelected ? 'bg-blue-100 text-blue-800' : 'hover:bg-gray-50 text-gray-500'}`}
                                        >
                                            <span className="text-gray-400 w-4 shrink-0">{idx}</span>
                                            <span className="truncate">{pointsStr}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    // ============ New: Raw Image List Logic ============
    const [rawImages, setRawImages] = useState([]);
    const sidebarFileInputRef = useRef(null);

    const fetchRawImages = useCallback(() => {
        // activeTab check removed to allow background refresh
        fetch(`${apiBaseUrl}/api/learning/raw-images`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setRawImages(data.data);
                }
            })
            .catch(err => console.error('Failed to load raw images:', err));
    }, [apiBaseUrl]);

    useEffect(() => {
        fetchRawImages();
    }, [fetchRawImages]);

    const handleSidebarUpload = async (e) => {
        const files = Array.from(e.target.files);
        if (!files || files.length === 0) return;

        // Reset file input
        if (sidebarFileInputRef.current) sidebarFileInputRef.current.value = '';

        // 1. Optimistic UI: Add all files immediately with uploading state
        const newTempFiles = files.map(file => ({
            name: file.name,
            isUploading: true,
            isLabeled: false
        }));

        setRawImages(prev => [...newTempFiles, ...prev]);

        // 2. Upload individually (Parallel)
        let isFirstSuccess = true;

        const uploadPromises = files.map(async (file) => {
            const formData = new FormData();
            formData.append('images', file); // Use 'images' key as backend expects

            try {
                const response = await fetch(`${apiBaseUrl}/api/learning/upload-raw`, {
                    method: 'POST',
                    body: formData
                });
                const data = await response.json();

                if (data.success && data.files.length > 0) {
                    const uploadedFilename = data.files[0];

                    // Update state to remove 'isUploading' for this file
                    setRawImages(prev => prev.map(img =>
                        img.name === file.name ? { ...img, name: uploadedFilename, isUploading: false } : img
                    ));

                    // Auto-select ONLY the first successfully uploaded file
                    if (isFirstSuccess) {
                        isFirstSuccess = false;
                        const url = `${apiBaseUrl}/api/learning/raw-images/${encodeURIComponent(uploadedFilename)}`;
                        // Small delay to ensure state update works smoothly
                        setTimeout(() => handleSwitchImage(url, true), 100);
                    }
                } else {
                    console.error('Upload failed for', file.name, data.error);
                    // Remove failed upload from list
                    setRawImages(prev => prev.filter(img => img.name !== file.name));
                    alert(`업로드 실패 (${file.name}): ${data.error || 'Unknown error'}`);
                }
            } catch (error) {
                console.error('Upload error for', file.name, error);
                setRawImages(prev => prev.filter(img => img.name !== file.name));
            }
        });

        await Promise.all(uploadPromises);
        fetchRawImages(); // Final sync with server
    };

    const handleDeleteImage = async (filename, e) => {
        e.stopPropagation();
        if (!window.confirm(`정말 '${filename}' 파일을 삭제하시겠습니까?`)) return;

        // Optimistic UI: Remove immediately from list
        setRawImages(prev => prev.filter(img => img.name !== filename));

        // If currently viewing this image, clear it
        if (currentImageUrl && currentImageUrl.includes(encodeURIComponent(filename))) {
            setCurrentImageUrl(null);
            setLabels([]);
            setOcrResults([]);
            setStageSize({ width: 0, height: 0 });
        }

        try {
            const response = await fetch(`${apiBaseUrl}/api/learning/raw-images/${encodeURIComponent(filename)}`, {
                method: 'DELETE'
            });
            const data = await response.json();
            if (data.success) {
                // setLoadedMsg('Deleted successfully');
                // setTimeout(() => setLoadedMsg(null), 1000);
            } else {
                alert('삭제 실패: ' + data.error);
                fetchRawImages(); // Revert on failure
            }
        } catch (error) {
            console.error('Delete error:', error);
            alert('삭제 중 오류 발생');
            fetchRawImages(); // Revert
        }
    };

    // ============ Renderers ============

    const renderFileSidebar = () => {
        return (
            <div className="w-[250px] bg-white border-r border-[#DADCE0] flex flex-col shrink-0 z-30 h-full">
                <div className="h-[52px] border-b border-[#DADCE0] flex items-center justify-between px-4 font-semibold text-[#202124]">
                    <div className="flex items-center">
                        <FileImage className="w-4 h-4 mr-2" />
                        File List ({rawImages.length})
                    </div>
                    <div className="flex items-center">
                        <input
                            type="file"
                            ref={sidebarFileInputRef}
                            className="hidden"
                            multiple
                            accept="image/*,application/pdf"
                            onChange={handleSidebarUpload}
                        />
                        <button
                            onClick={() => sidebarFileInputRef.current?.click()}
                            className="p-1.5 hover:bg-gray-100 rounded text-gray-500 hover:text-blue-600 transition-colors"
                            title="Upload New File"
                        >
                            <Upload className="w-4 h-4" />
                        </button>
                    </div>
                </div>
                <div className="flex-1 overflow-y-auto p-2 space-y-1">
                    {rawImages.map((img) => {
                        // Simple check if current imageurl contains this filename
                        const isActive = currentImageUrl && currentImageUrl.includes(encodeURIComponent(img.name));
                        // or more robust check?
                        const isSelected = currentImageUrl && currentImageUrl.indexOf(img.name) !== -1;

                        return (
                            <div
                                key={img.name}
                                onClick={() => !img.isUploading && handleSwitchImage(`${apiBaseUrl}/api/learning/raw-images/${encodeURIComponent(img.name)}`)}
                                className={`group flex items-center gap-2 p-2 rounded cursor-pointer text-xs truncate transition-colors
                                    ${isSelected ? 'bg-blue-50 text-blue-700 border border-blue-200' : 'hover:bg-gray-50 text-gray-600'}
                                    ${img.isUploading ? 'opacity-70 cursor-wait' : ''}
                                `}
                            >
                                <div className={`w-2 h-2 rounded-full flex-shrink-0 ${img.isLabeled ? 'bg-green-500' : 'bg-gray-300'}`} />
                                <span className="truncate flex-1">{img.name}</span>
                                {img.isUploading ? (
                                    <Loader2 className="w-3 h-3 text-blue-500 animate-spin" />
                                ) : (
                                    <div className="flex items-center gap-1">
                                        {img.isLabeled && <CheckCircle className="w-3 h-3 text-green-500" />}
                                        <button
                                            onClick={(e) => handleDeleteImage(img.name, e)}
                                            className="p-1 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded opacity-0 group-hover:opacity-100 transition-all"
                                            title="Delete"
                                        >
                                            <Trash2 className="w-3 h-3" />
                                        </button>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };



    return (
        <div className={isEmbedded
            ? "w-full h-full flex flex-col"
            : "fixed inset-0 z-[1001] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
        }>
            <div className={isEmbedded
                ? "w-full h-full flex overflow-hidden"
                : "bg-[#F0F2F5] w-full h-full max-w-[1800px] max-h-[1200px] rounded-xl shadow-2xl flex overflow-hidden border border-[#DADCE0]"
            }>
                {/* 1. New Left Panel: File List - 임베디드 모드에서 숨김 */}
                {!isEmbedded && renderFileSidebar()}

                {/* 2. Main Canvas Area (Center) */}
                <div className="flex-1 relative flex flex-col min-w-0 bg-[#E8EAED]">
                    {/* Header Bar - 임베디드 모드에서는 숨김 */}
                    {!isEmbedded && (
                        <div className="h-[52px] bg-white border-b border-[#DADCE0] flex items-center justify-between px-4 shadow-sm z-40">
                            <div className="flex items-center gap-6">
                                <div className="flex items-center gap-3">
                                    <h2 className="font-semibold text-lg text-[#202124]">{templateName}</h2>
                                    <span className="text-xs px-2 py-0.5 bg-gray-100 rounded text-[#5F6368] font-medium border border-gray-200">
                                        Page {currentPage} / {totalPages}
                                    </span>
                                </div>

                                {/* Workflow Action Buttons - 심플 스타일 */}
                                <div className="flex items-center gap-1">
                                    {/* 자동 실행 */}
                                    <button
                                        onClick={handleAutoProcess}
                                        disabled={isAutoProcessing || !currentImageUrl}
                                        className={`flex items-center gap-1.5 px-3 py-1.5 rounded text-xs font-medium border transition-all ${isAutoProcessing ? 'bg-gray-100 text-gray-400 border-gray-200' : 'bg-white hover:bg-gray-50 text-gray-700 border-gray-300'
                                            }`}
                                        title="OCR → 검증 → 저장 자동 실행"
                                    >
                                        {isAutoProcessing ? <RefreshCw className="w-3.5 h-3.5 animate-spin" /> : <Zap className="w-3.5 h-3.5" />}
                                        자동실행
                                    </button>

                                    <div className="w-px h-4 bg-gray-200 mx-1" />

                                    {/* Step 1: OCR (PaddleOCR + AI병합 + Gemini 병렬) */}
                                    <button
                                        onClick={handleOcrPipeline}
                                        disabled={!currentImageUrl || isProgressiveProcessing}
                                        className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded text-xs font-medium border transition-all ${labels.some(l => l.source === 'vllm' || l.source === 'ai-merge') ? 'bg-green-50 text-green-700 border-green-200' : 'bg-white hover:bg-gray-50 text-gray-600 border-gray-300'
                                            }`}
                                        title="PaddleOCR(즉시) + AI병합 + Gemini(병렬)"
                                    >
                                        {isProgressiveProcessing ? <RefreshCw className="w-3 h-3 animate-spin" /> : (labels.some(l => l.source === 'vllm' || l.source === 'ai-merge') ? <Check className="w-3 h-3" /> : <span className="w-3 h-3 text-center text-[10px]">1</span>)}
                                        OCR
                                    </button>

                                    {/* ⭐ 프롬프트 편집 버튼 */}
                                    <button
                                        onClick={openPromptEditor}
                                        disabled={!templateId}
                                        className="flex items-center gap-1 px-2 py-1.5 rounded text-xs font-medium border bg-white hover:bg-purple-50 text-purple-600 border-purple-200 transition-all"
                                        title="AI병합/Gemini 프롬프트 확인 및 수정"
                                    >
                                        ⚙️
                                    </button>

                                    <div className="text-gray-300">→</div>

                                    {/* Step 2: 검증 (Gemini 호출 + 비교) */}
                                    <button
                                        onClick={handleVerifyWithGemini}
                                        disabled={!labels.some(l => l.source === 'vllm') || isVerifying}
                                        className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded text-xs font-medium border transition-all ${labels.some(l => l.geminiText) ? 'bg-green-50 text-green-700 border-green-200' : 'bg-white hover:bg-gray-50 text-gray-600 border-gray-300'
                                            }`}
                                        title="Gemini로 검증 (차이점 빨간색 표시)"
                                    >
                                        {isVerifying ? <RefreshCw className="w-3 h-3 animate-spin" /> : (labels.some(l => l.geminiText) ? <Check className="w-3 h-3" /> : <Sparkles className="w-3 h-3" />)}
                                        검증
                                    </button>

                                    <div className="text-gray-300">→</div>

                                    {/* Step 3: 저장 */}
                                    <button
                                        onClick={handleVerifyAndSave}
                                        disabled={labels.length === 0}
                                        className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded text-xs font-medium border transition-all ${isSaved ? 'bg-green-50 text-green-700 border-green-200' : 'bg-white hover:bg-gray-50 text-gray-600 border-gray-300'
                                            }`}
                                        title="저장"
                                    >
                                        {isSaved ? <Check className="w-3 h-3" /> : <Save className="w-3 h-3" />}
                                        저장
                                    </button>
                                </div>
                            </div>

                            <div className="flex items-center gap-2">
                                <button onClick={() => setShowHelpModal(true)} className="p-2 hover:bg-gray-100 rounded text-[#5F6368]" title="단축키 도움말 (?)">
                                    <AlertCircle className="w-5 h-5" />
                                </button>
                                {/* X 닫기 버튼만 유지 */}
                                <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded text-[#5F6368] transition">
                                    <X className="w-5 h-5" />
                                </button>
                            </div>
                        </div>
                    )}


                    {/* Floating Toolbar - 상단 고정 & 1.5배 크기 */}
                    <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-white/95 backdrop-blur-sm rounded-b-md shadow-sm border border-t-0 border-gray-200 px-2 py-1 flex items-center gap-1 z-30">
                        <button onClick={() => setTool('select')} className={`p-2.5 rounded ${tool === 'select' ? 'bg-blue-50 text-blue-600' : 'hover:bg-gray-100 text-gray-500'}`} title="선택 (V)">
                            <MousePointer className="w-5 h-5" />
                        </button>
                        <button onClick={() => setTool('draw')} className={`p-2.5 rounded ${tool === 'draw' ? 'bg-blue-50 text-blue-600' : 'hover:bg-gray-100 text-gray-500'}`} title="박스 그리기 (W)">
                            <Square className="w-5 h-5" />
                        </button>
                        <div className="w-px h-6 bg-gray-200 mx-1" />

                        <button onClick={undo} className="p-2.5 hover:bg-gray-100 rounded text-gray-500" title="실행 취소"><ChevronLeft className="w-5 h-5" /></button>
                        <button onClick={redo} className="p-2.5 hover:bg-gray-100 rounded text-gray-500" title="다시 실행"><ChevronRight className="w-5 h-5" /></button>

                        <div className="w-px h-6 bg-gray-200 mx-1" />

                        <button onClick={zoomOut} className="p-2.5 hover:bg-gray-100 rounded text-gray-500" title="축소"><ZoomOut className="w-5 h-5" /></button>
                        <span className="text-xs font-mono w-10 text-center text-gray-600">{Math.round(scale * 100)}%</span>
                        <button onClick={zoomIn} className="p-2.5 hover:bg-gray-100 rounded text-gray-500" title="확대"><ZoomIn className="w-5 h-5" /></button>

                        <div className="w-px h-6 bg-gray-200 mx-1" />

                        <button onClick={() => setShowGrid(!showGrid)} className={`p-2.5 rounded ${showGrid ? 'bg-blue-50 text-blue-600' : 'hover:bg-gray-100 text-gray-500'}`} title="그리드 (G)">
                            <Grid className="w-5 h-5" />
                        </button>
                        <button onClick={handleRotate} disabled={!image} title="Rotate 90°" className="p-2.5 hover:bg-gray-100 rounded text-gray-500 disabled:opacity-30">
                            <RotateCw className="w-5 h-5" />
                        </button>
                        <button onClick={handlePaddleOnly} disabled={!image} title="Fast OCR" className={`p-2.5 rounded ${!image ? 'text-gray-300' : 'text-gray-600 hover:bg-gray-50'}`}>
                            <Zap className="w-5 h-5" />
                        </button>

                        <div className="w-px h-6 bg-gray-200 mx-1" />

                        {/* Labels Toggle */}
                        <label className={`flex items-center gap-1 px-2 py-1.5 rounded cursor-pointer text-xs ${showBoxLabels ? 'bg-blue-50 text-blue-600' : 'hover:bg-gray-100 text-gray-500'}`} title="Show labels">
                            <input type="checkbox" checked={showBoxLabels} onChange={(e) => setShowBoxLabels(e.target.checked)} className="w-4 h-4 rounded border-gray-300" />
                            <span>Labels</span>
                        </label>
                        <div className="w-px h-6 bg-gray-200 mx-1" />

                        <button onClick={resetLabels} className="p-2.5 hover:bg-red-50 hover:text-red-500 rounded text-gray-500" title="초기화">
                            <Trash2 className="w-5 h-5" />
                        </button>
                    </div>


                    {/* Loaded Toast */}
                    {loadedMsg && (
                        <div className="absolute top-20 left-1/2 -translate-x-1/2 bg-gray-800 text-white px-6 py-3 rounded-lg shadow-xl z-50 animate-fadeInUp flex items-center gap-3">
                            <CheckCircle className="w-5 h-5 text-green-400" />
                            <span>{loadedMsg}</span>
                        </div>
                    )}

                    {/* Loading Toast */}
                    {isSmartLabeling && (
                        <div className="absolute top-20 left-1/2 -translate-x-1/2 bg-gray-900/90 text-white px-4 py-2.5 rounded-full text-sm font-medium flex items-center gap-2.5 z-50 shadow-xl backdrop-blur-sm animate-pulse">
                            <RefreshCw className="w-4 h-4 animate-spin text-purple-400" />
                            <span>AI가 문서를 분석하고 있습니다...</span>
                        </div>
                    )}

                    {/* Empty State Overlay - 제거됨 */}

                    {/* Canvas Stage */}
                    <div ref={containerRef} className="flex-1 overflow-auto flex items-center justify-center relative touch-none" style={{ backgroundImage: 'radial-gradient(#BDC1C6 1px, transparent 1px)', backgroundSize: '20px 20px' }}>
                        <Stage
                            width={stageSize.width}
                            height={stageSize.height}
                            scaleX={scale}
                            scaleY={scale}
                            onMouseDown={handleMouseDown}
                            onMouseMove={handleMouseMove}
                            onMouseUp={handleMouseUp}
                            ref={stageRef}
                        >
                            <Layer>
                                {/* Image */}
                                <KonvaImage image={image} />

                                {/* Grid */}
                                {showGrid && image && (
                                    <Group>
                                        {Array.from({ length: Math.ceil(image.width / GRID_SIZE) }).map((_, i) => (
                                            <Line
                                                key={`v-${i}`}
                                                points={[i * GRID_SIZE, 0, i * GRID_SIZE, image.height]}
                                                stroke="rgba(0, 0, 0, 0.1)"
                                                strokeWidth={1}
                                            />
                                        ))}
                                        {Array.from({ length: Math.ceil(image.height / GRID_SIZE) }).map((_, i) => (
                                            <Line
                                                key={`h-${i}`}
                                                points={[0, i * GRID_SIZE, image.width, i * GRID_SIZE]}
                                                stroke="rgba(0, 0, 0, 0.1)"
                                                strokeWidth={1}
                                            />
                                        ))}
                                    </Group>
                                )}

                                {/* Regular Labels */}
                                {console.log('🎨 [Konva] 렌더링 labels:', labels.length, labels.filter(l => l.bbox).length)}
                                {labels.filter(label => label.bbox).map((label, i) => {
                                    const isSelected = selectedId === label.id || selectedIds.includes(label.id);
                                    // ⭐ 필드 클릭 시 하이라이트 여부 확인 (텍스트 부분 매칭)
                                    const normalizedTarget = String(highlightedFieldKey || '').replace(/\s+/g, '').toLowerCase();
                                    const normalizedText = String(label.text || '').replace(/\s+/g, '').toLowerCase();
                                    const isHighlighted = highlightedFieldKey && normalizedTarget.length > 2 && normalizedText.length > 2 && (
                                        label.fieldKey === highlightedFieldKey ||
                                        normalizedText.includes(normalizedTarget) ||
                                        normalizedTarget.includes(normalizedText)
                                    );
                                    if (highlightedFieldKey) {
                                        console.log(`🔲 [Konva] Rect ${label.id}: text="${label.text?.slice(0, 25)}", target="${highlightedFieldKey?.slice(0, 25)}", match=${isHighlighted}`);
                                    }
                                    return (
                                        <Group
                                            key={label.id}
                                            id={label.id}
                                            x={label.bbox.x}
                                            y={label.bbox.y}
                                            draggable
                                            onClick={(e) => {
                                                e.cancelBubble = true;
                                                setSelectedId(label.id);
                                            }}
                                            onDragEnd={(e) => {
                                                const newBbox = { ...label.bbox, x: e.target.x(), y: e.target.y() };
                                                const newLabels = labels.map(l => {
                                                    if (l.id === label.id) {
                                                        return {
                                                            ...l,
                                                            bbox: newBbox
                                                        };
                                                    }
                                                    return l;
                                                });
                                                setLabels(newLabels);
                                                // Auto Re-recognize on Drag End (Only for manual labels)
                                                if (!label.isSmartLabel) {
                                                    reRecognize(label.id, newBbox);
                                                }
                                            }}
                                        >
                                            <Rect
                                                ref={node => {
                                                    shapeRefs.current[label.id] = node;
                                                }}
                                                width={label.bbox.width}
                                                height={label.bbox.height}
                                                stroke={isHighlighted ? '#FF0000' : (isSelected ? '#00CC66' : '#39FF14')}
                                                strokeWidth={isHighlighted ? 3 / scale : (isSelected ? 1.5 / scale : 1 / scale)}
                                                fill={isHighlighted ? 'rgba(255, 0, 0, 0.15)' : (isSelected ? 'rgba(0, 204, 102, 0.08)' : 'rgba(0,0,0,0)')}
                                                dash={isHighlighted ? null : [2 / scale, 2 / scale]}
                                                onTransformEnd={() => {
                                                    const node = shapeRefs.current[label.id];
                                                    const scaleX = node.scaleX();
                                                    const scaleY = node.scaleY();

                                                    // Calculate new dimensions/position
                                                    // Rect is inside Group, so we need to account for relative transform
                                                    const groupNode = node.getParent();
                                                    const newX = groupNode.x() + node.x();
                                                    const newY = groupNode.y() + node.y();
                                                    const newW = Math.max(5, node.width() * scaleX);
                                                    const newH = Math.max(5, node.height() * scaleY);

                                                    // Reset node transform (state will drive the render)
                                                    node.scaleX(1);
                                                    node.scaleY(1);
                                                    node.x(0);
                                                    node.y(0); // Assuming Rect is 0,0 relative to Group

                                                    const newBbox = { ...label.bbox, x: newX, y: newY, width: newW, height: newH };

                                                    // Update State
                                                    const newLabels = labels.map(l => l.id === label.id ? { ...l, bbox: newBbox } : l);
                                                    setLabels(newLabels);

                                                    // Auto Re-recognize (Only for manual labels)
                                                    if (!label.isSmartLabel) {
                                                        reRecognize(label.id, newBbox);
                                                    }
                                                }}
                                            />
                                            {/* 선택된 박스에 모서리 핸들 표시 */}
                                            {isSelected && (
                                                <>
                                                    {/* 좌상 */}
                                                    <Circle x={0} y={0} radius={4 / scale} fill="#00CC66" stroke="#fff" strokeWidth={1 / scale} />
                                                    {/* 우상 */}
                                                    <Circle x={label.bbox.width} y={0} radius={4 / scale} fill="#00CC66" stroke="#fff" strokeWidth={1 / scale} />
                                                    {/* 좌하 */}
                                                    <Circle x={0} y={label.bbox.height} radius={4 / scale} fill="#00CC66" stroke="#fff" strokeWidth={1 / scale} />
                                                    {/* 우하 */}
                                                    <Circle x={label.bbox.width} y={label.bbox.height} radius={4 / scale} fill="#00CC66" stroke="#fff" strokeWidth={1 / scale} />
                                                </>
                                            )}
                                            {showBoxLabels && (
                                                <Text
                                                    text={`${i + 1}. ${label.geminiText || label.text || label.fieldKey || ''}`}
                                                    fontSize={12 / scale}
                                                    fill="#39FF14"
                                                    x={0}
                                                    y={-(16 / scale)}
                                                    padding={0}
                                                    fontStyle="bold"
                                                />
                                            )}
                                        </Group>
                                    );
                                })}

                                {/* Smart Mapping OCR Overlays */}
                                {/* Smart Mapping OR Learning Mode OCR Overlays */}
                                {(smartMappingMode || activeTab === 'learning') && ocrResults.map(ocr => {
                                    const isLearningMode = activeTab === 'learning';
                                    const isSelected = selectedOcrIds.includes(ocr.id) || (isLearningMode && learningSelectedId === ocr.id);

                                    // Hide matched items only in Smart Mapping mode to reduce clutter
                                    // In Learning Mode, show everything
                                    if (smartMappingMode && ocr.matched && !isSelected) return null;

                                    const strokeColor = isSelected ? '#3b82f6' : '#f59e0b';
                                    const fillColor = isSelected ? 'rgba(59, 130, 246, 0.3)' : 'rgba(245, 158, 11, 0.1)';

                                    return (
                                        <React.Fragment key={`ocr-${ocr.id}`}>
                                            <Rect
                                                x={ocr.bbox.x}
                                                y={ocr.bbox.y}
                                                width={ocr.bbox.width}
                                                height={ocr.bbox.height}
                                                stroke={strokeColor}
                                                strokeWidth={isSelected ? 2 / scale : 1 / scale}
                                                fill={fillColor}
                                                dash={[2, 2]}
                                                onClick={(e) => {
                                                    e.cancelBubble = true;
                                                    if (isLearningMode) {
                                                        setLearningSelectedId(ocr.id);
                                                    } else {
                                                        toggleOcrSelection(ocr.id, e.evt.ctrlKey || e.evt.metaKey);
                                                    }
                                                }}
                                            />
                                            {showBoxLabels && (
                                                <Text
                                                    x={ocr.bbox.x + 2}
                                                    y={ocr.bbox.y + 2}
                                                    text={ocr.text}
                                                    fontSize={12 / scale}
                                                    fill="#000"
                                                    fontStyle="bold"
                                                    shadowColor="#fff"
                                                    shadowBlur={2}
                                                    shadowOffset={{ x: 1, y: 1 }}
                                                    listening={false}
                                                />
                                            )}
                                        </React.Fragment>
                                    );
                                })}

                                {/* Drawing Preview */}
                                {isDrawing && newRect && (
                                    <Rect
                                        x={newRect.x}
                                        y={newRect.y}
                                        width={newRect.width}
                                        height={newRect.height}
                                        stroke="#1A73E8"
                                        strokeWidth={1 / scale}
                                        fill="rgba(26, 115, 232, 0.2)"
                                        dash={[4, 4]}
                                    />
                                )}

                                {/* Transformer */}
                                <Transformer
                                    ref={transformerRef}
                                    boundBoxFunc={(oldBox, newBox) => {
                                        if (newBox.width < 5 || newBox.height < 5) return oldBox;
                                        return newBox;
                                    }}
                                    anchorSize={6}
                                    rotateEnabled={false}
                                    borderEnabled={false}
                                    anchorStroke="#39FF14"
                                    anchorFill="#FFFFFF"
                                />
                            </Layer>
                        </Stage>
                    </div>
                </div>

                {/* 3. Right Data Panel - 임베디드 모드에서 숨김 */}
                {!isEmbedded && renderRightPanel()}
            </div>

            {/* Help Modal */}
            {
                showHelpModal && (
                    <div className="absolute inset-0 bg-black/50 flex items-center justify-center z-[1100]" onClick={() => setShowHelpModal(false)}>
                        <div className="bg-white rounded-xl shadow-2xl p-6 max-w-2xl w-full border border-gray-200" onClick={e => e.stopPropagation()}>
                            <div className="flex items-center justify-between mb-6">
                                <div className="flex items-center gap-4">
                                    <h3 className="text-lg font-bold flex items-center gap-2">
                                        <div className="p-1 bg-gray-100 rounded text-gray-600"><AlertCircle className="w-5 h-5" /></div>
                                        도움말 & 가이드
                                    </h3>
                                    <div className="flex bg-gray-100 p-1 rounded-lg">
                                        <button
                                            onClick={() => setHelpTab('shortcuts')}
                                            className={`px-3 py-1.5 text-xs font-medium rounded-md transition-all ${helpTab === 'shortcuts' ? 'bg-white text-gray-800 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}
                                        >
                                            단축키 (Shortcuts)
                                        </button>
                                        <button
                                            onClick={() => setHelpTab('guide')}
                                            className={`px-3 py-1.5 text-xs font-medium rounded-md transition-all ${helpTab === 'guide' ? 'bg-white text-gray-800 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}
                                        >
                                            기능 가이드 (Feature Guide)
                                        </button>
                                    </div>
                                </div>
                                <button onClick={() => setShowHelpModal(false)} className="p-1 hover:bg-gray-100 rounded"><X className="w-5 h-5 text-gray-400" /></button>
                            </div>

                            {helpTab === 'shortcuts' ? (
                                <div className="space-y-4">
                                    <div className="grid grid-cols-2 gap-x-8 gap-y-2 text-sm">
                                        <div className="col-span-2 font-semibold text-gray-900 border-b pb-1 mb-1">기본 조작 (Basic Controls)</div>
                                        <div className="flex justify-between"><span>박스 그리기 (Draw)</span> <kbd className="bg-gray-100 px-2 rounded font-mono">W</kbd></div>
                                        <div className="flex justify-between"><span>선택 모드 (Select)</span> <kbd className="bg-gray-100 px-2 rounded font-mono">V</kbd></div>
                                        <div className="flex justify-between"><span>삭제 (Delete)</span> <kbd className="bg-gray-100 px-2 rounded font-mono">Del</kbd></div>
                                        <div className="flex justify-between"><span>복제 (Duplicate)</span> <kbd className="bg-gray-100 px-2 rounded font-mono">Ctrl+D</kbd></div>

                                        <div className="col-span-2 font-semibold text-gray-900 border-b pb-1 mb-1 mt-2">화면 조작 (View Controls)</div>
                                        <div className="flex justify-between"><span>확대/축소</span> <kbd className="bg-gray-100 px-2 rounded font-mono">Wheel</kbd></div>
                                        <div className="flex justify-between"><span>그리드 (Grid)</span> <kbd className="bg-gray-100 px-2 rounded font-mono">G</kbd></div>

                                        <div className="col-span-2 font-semibold text-gray-900 border-b pb-1 mb-1 mt-2">고급 기능 (Advanced)</div>
                                        <div className="flex justify-between"><span>다중 선택</span> <kbd className="bg-gray-100 px-2 rounded font-mono">Ctrl+Click</kbd></div>
                                        <div className="flex justify-between"><span>실행 취소 (Undo)</span> <kbd className="bg-gray-100 px-2 rounded font-mono">Ctrl+Z</kbd></div>
                                    </div>
                                    <div className="pt-4 border-t border-gray-100 text-xs text-center text-gray-500">
                                        Tip: 화살표 키로 1px씩 미세 이동이 가능합니다. (Shift+Arrow: 10px)
                                    </div>
                                </div>
                            ) : (
                                <div className="space-y-6 animate-fadeIn">
                                    <div className="flex gap-4 items-start pb-4 border-b border-gray-100">
                                        <div className="p-2 bg-blue-50 rounded-lg text-blue-600 mt-1">
                                            <Save className="w-5 h-5" />
                                        </div>
                                        <div>
                                            <h4 className="font-bold text-gray-900 mb-1">Save (임시 저장)</h4>
                                            <p className="text-sm text-gray-600 leading-relaxed">
                                                현재 작업 중인 라벨링 내용을 <b>템플릿에만 저장</b>합니다.
                                                <br />
                                                <span className="text-gray-500 text-xs">작업 내역을 클라우드에 백업하는 용도이며, 아직 학습 데이터로는 사용되지 않습니다.</span>
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex gap-4 items-start pb-4 border-b border-gray-100">
                                        <div className="p-2 bg-green-50 rounded-lg text-green-600 mt-1">
                                            <BrainCircuit className="w-5 h-5" />
                                        </div>
                                        <div>
                                            <h4 className="font-bold text-gray-900 mb-1">Verify & Save (검증 및 학습용 저장)</h4>
                                            <p className="text-sm text-gray-600 leading-relaxed">
                                                AI가 데이터를 검증하고, <b>학습 가능한 데이터(Ground Truth)로 변환하여 저장</b>합니다.
                                                <br />
                                                <span className="text-gray-500 text-xs font-semibold text-green-700">이 단계를 거쳐야 'Training' 탭에서 학습을 시작할 수 있습니다.</span>
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex gap-4 items-start">
                                        <div className="p-2 bg-purple-50 rounded-lg text-purple-600 mt-1">
                                            <Zap className="w-5 h-5" />
                                        </div>
                                        <div>
                                            <h4 className="font-bold text-gray-900 mb-1">Training (학습 시작)</h4>
                                            <p className="text-sm text-gray-600 leading-relaxed">
                                                우측 패널의 <b>'Training' 탭</b>에서 사용 가능합니다.
                                                <br />
                                                <span className="text-gray-500 text-xs">작업 내역을 클라우드에 백업하는 용도이며, 아직 학습 데이터로는 사용되지 않습니다.</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                )
            }

            {/* 🤖 AI Merge Preview Modal */}
            {
                showMergePreview && mergePreviewData && (
                    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]">
                        <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[80vh] flex flex-col">
                            <div className="flex items-center justify-between px-6 py-4 border-b">
                                <h3 className="text-lg font-semibold flex items-center gap-2">
                                    <BrainCircuit className="w-5 h-5 text-purple-600" />
                                    vLLM 병합 결과 미리보기
                                </h3>
                                <button
                                    onClick={() => { setShowMergePreview(false); setMergePreviewData(null); }}
                                    className="text-gray-400 hover:text-gray-600"
                                >
                                    <X className="w-5 h-5" />
                                </button>
                            </div>
                            <div className="flex-1 overflow-y-auto px-6 py-4">
                                <p className="text-sm text-gray-600 mb-4">
                                    템플릿 필드별 추출 결과입니다. 수정 후 '적용' 버튼을 클릭하세요.
                                </p>
                                <div className="space-y-3">
                                    {templateFields.map((field, idx) => {
                                        const key = field.key || field.fieldKey || field.name;
                                        const displayName = field.displayName || field.label || key;
                                        const value = mergePreviewData[key] || '';
                                        return (
                                            <div key={idx} className="flex items-center gap-3">
                                                <label className="w-28 text-sm font-medium text-gray-700 truncate" title={displayName}>
                                                    {displayName}
                                                </label>
                                                <input
                                                    type="text"
                                                    value={value}
                                                    onChange={(e) => handleMergePreviewChange(key, e.target.value)}
                                                    className="flex-1 px-3 py-2 border rounded text-sm focus:ring-2 focus:ring-purple-500"
                                                />
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="flex justify-end gap-3 px-6 py-4 border-t bg-gray-50">
                                <button
                                    onClick={() => { setShowMergePreview(false); setMergePreviewData(null); }}
                                    className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded"
                                >
                                    취소
                                </button>
                                <button
                                    onClick={applyMergePreview}
                                    className="px-4 py-2 text-sm bg-purple-600 text-white hover:bg-purple-700 rounded flex items-center gap-2"
                                >
                                    <Check className="w-4 h-4" />
                                    적용
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }

            {/* 프롬프트 편집 모달 */}
            {
                showPromptEditor && (
                    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
                        <div className="bg-white rounded-lg shadow-xl w-[800px] max-h-[90vh] flex flex-col">
                            {/* 헤더 */}
                            <div className="flex items-center justify-between px-5 py-3 border-b">
                                <div>
                                    <h2 className="text-base font-semibold text-gray-800">프롬프트 편집</h2>
                                    <p className="text-xs text-gray-500">템플릿: {promptData?.templateName || templateId}</p>
                                </div>
                                <button
                                    onClick={() => setShowPromptEditor(false)}
                                    className="p-1.5 hover:bg-gray-100 rounded text-gray-400 hover:text-gray-600"
                                >
                                    <X className="w-4 h-4" />
                                </button>
                            </div>

                            {/* 탭 */}
                            <div className="flex border-b text-sm">
                                <button
                                    onClick={() => setActivePromptTab('ocrMerge')}
                                    className={`flex-1 px-4 py-2.5 font-medium transition-colors ${activePromptTab === 'ocrMerge' ? 'text-gray-800 border-b-2 border-gray-800' : 'text-gray-400 hover:text-gray-600'}`}
                                >
                                    AI 병합
                                </button>
                                <button
                                    onClick={() => setActivePromptTab('gemini')}
                                    className={`flex-1 px-4 py-2.5 font-medium transition-colors ${activePromptTab === 'gemini' ? 'text-gray-800 border-b-2 border-gray-800' : 'text-gray-400 hover:text-gray-600'}`}
                                >
                                    Gemini
                                </button>
                            </div>

                            {/* 콘텐츠 */}
                            <div className="flex-1 overflow-y-auto p-5">
                                {promptLoading ? (
                                    <div className="flex items-center justify-center h-32 text-gray-400 text-sm">
                                        로딩 중...
                                    </div>
                                ) : promptData && (
                                    <div className="space-y-4">
                                        {/* 프롬프트 편집 영역 */}
                                        <div>
                                            <div className="flex items-center justify-between mb-2">
                                                <label className="text-sm font-medium text-gray-700">
                                                    프롬프트
                                                </label>
                                                <div className="flex items-center gap-2">
                                                    {/* 언어 토글 (Gemini 탭에서만 표시) */}
                                                    {activePromptTab === 'gemini' && (
                                                        <div className="flex border rounded text-xs">
                                                            <button
                                                                onClick={() => togglePromptLanguage('ko')}
                                                                className={`px-2 py-0.5 ${promptLanguage === 'ko' ? 'bg-gray-800 text-white' : 'text-gray-500 hover:bg-gray-100'}`}
                                                            >
                                                                한글
                                                            </button>
                                                            <button
                                                                onClick={() => togglePromptLanguage('en')}
                                                                className={`px-2 py-0.5 ${promptLanguage === 'en' ? 'bg-gray-800 text-white' : 'text-gray-500 hover:bg-gray-100'}`}
                                                            >
                                                                EN
                                                            </button>
                                                        </div>
                                                    )}
                                                    <button
                                                        onClick={() => {
                                                            // 자동 생성 프롬프트로 초기화
                                                            if (activePromptTab === 'ocrMerge') {
                                                                setCustomOcrMergePrompt(promptData.ocrMerge?.auto || '');
                                                            } else {
                                                                setCustomGeminiPrompt(promptData.gemini?.auto || '');
                                                            }
                                                        }}
                                                        className="text-xs text-gray-500 hover:text-gray-700 px-2 py-1 border rounded hover:bg-gray-50"
                                                    >
                                                        자동 생성으로 초기화
                                                    </button>
                                                </div>
                                            </div>
                                            <textarea
                                                value={activePromptTab === 'ocrMerge'
                                                    ? (customOcrMergePrompt || promptData.ocrMerge?.auto || '')
                                                    : (customGeminiPrompt || promptData.gemini?.auto || '')}
                                                onChange={(e) => activePromptTab === 'ocrMerge'
                                                    ? setCustomOcrMergePrompt(e.target.value)
                                                    : setCustomGeminiPrompt(e.target.value)}
                                                className="w-full h-[560px] p-3 border rounded text-sm font-mono resize-none focus:ring-1 focus:ring-gray-300 focus:border-gray-400 text-gray-700"
                                                spellCheck="false"
                                            />
                                        </div>

                                        {/* 예시 - 작은 폰트 */}
                                        <div className="text-xs text-gray-400 border-t pt-3">
                                            <span className="font-medium text-gray-500">예시:</span>
                                            <span className="ml-2">성명: 한글만 추출</span>
                                            <span className="mx-1">|</span>
                                            <span>주민등록번호: 뒷자리 마스킹</span>
                                            <span className="mx-1">|</span>
                                            <span>주소: 도로명만 추출</span>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* 푸터 */}
                            <div className="flex justify-end items-center gap-2 px-5 py-3 border-t bg-gray-50">
                                <button
                                    onClick={() => setShowPromptEditor(false)}
                                    className="px-4 py-1.5 text-sm text-gray-600 hover:bg-gray-100 rounded"
                                >
                                    취소
                                </button>
                                <button
                                    onClick={savePrompts}
                                    disabled={promptLoading}
                                    className="px-5 py-1.5 text-sm bg-gray-800 text-white hover:bg-gray-700 rounded"
                                >
                                    저장
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }
        </div >
    );
}

export default OCRLabelingModal;

